var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Button: () => Button,
  ButtonIcon: () => ButtonIcon,
  ButtonText: () => ButtonText,
  ComponentNode: () => ComponentNode,
  Explorer: () => Explorer,
  GroupNode: () => GroupNode,
  IconButton: () => IconButton,
  Layout: () => Layout,
  LayoutProvider: () => LayoutProvider,
  LeafNodeStyleWrapper: () => LeafNodeStyleWrapper,
  Node: () => Node,
  RootNode: () => RootNode,
  RootNodeText: () => RootNodeText,
  Sidebar: () => Sidebar,
  StorageProvider: () => StorageProvider,
  StoryNode: () => StoryNode,
  Tree: () => Tree,
  isExpandType: () => isExpandType,
  transformStoryIndexToStoriesHash: () => transformStoryIndexToStoriesHash,
  transformStoryIndexV2toV3: () => transformStoryIndexV2toV3,
  transformStoryIndexV3toV4: () => transformStoryIndexV3toV4,
  useCombination: () => useCombination,
  useLayout: () => useLayout,
  useStorage: () => useStorage
});
module.exports = __toCommonJS(src_exports);

// src/TreeNode.tsx
var import_react_native_theming2 = require("@storybook/react-native-theming");

// src/icon/ComponentIcon.tsx
var import_react_native_svg = __toESM(require("react-native-svg"));
var import_jsx_runtime = require("react/jsx-runtime");
function ComponentIcon({ color = "#029CFD", ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native_svg.default, { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react_native_svg.Path,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.5.004a2.5 2.5 0 00-2.5 2.5v7a2.5 2.5 0 002.5 2.5h7a2.5 2.5 0 002.5-2.5v-7a2.5 2.5 0 00-2.5-2.5h-7zm8.5 5.5H6.5v-4.5h3a1.5 1.5 0 011.5 1.5v3zm0 1v3a1.5 1.5 0 01-1.5 1.5h-3v-4.5H11zm-5.5 4.5v-4.5H1v3a1.5 1.5 0 001.5 1.5h3zM1 5.504h4.5v-4.5h-3a1.5 1.5 0 00-1.5 1.5v3z",
      fill: color
    }
  ) });
}

// src/icon/GroupIcon.tsx
var import_react_native_svg2 = __toESM(require("react-native-svg"));
var import_jsx_runtime2 = require("react/jsx-runtime");
function GroupIcon({ color = "#6F2CAC", ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_react_native_svg2.default, { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_react_native_svg2.Path,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.962 3.704L5.376 2.118H1.057v9.514h12.685V3.704h-6.78zM7.4 2.647L6.124 1.37a1.057 1.057 0 00-.748-.31H.53A.529.529 0 000 1.59v10.57c0 .292.237.529.529.529H14.27a.529.529 0 00.528-.529V3.175a.529.529 0 00-.528-.528H7.4z",
      fill: color
    }
  ) });
}

// src/icon/StoryIcon.tsx
var import_react_native_svg3 = __toESM(require("react-native-svg"));
var import_jsx_runtime3 = require("react/jsx-runtime");
function StoryIcon({ color = "#37D5D3", ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_react_native_svg3.default, { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    import_react_native_svg3.Path,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 0h6c.237 0 .428.192.428.429V11.57c0 .224-.17.407-.389.427a.396.396 0 01-.318-.101L6 9.565l-2.721 2.332a.395.395 0 01-.325.1.429.429 0 01-.383-.426V.43C2.571.192 2.763 0 3 0zm.428 10.64l2.284-1.958.034-.028a.39.39 0 01.289-.081c.087.007.172.04.244.102L8.57 10.64V.857H3.428v9.783z",
      fill: color
    }
  ) });
}

// src/icon/CollapseIcon.tsx
var import_react_native_theming = require("@storybook/react-native-theming");
var import_react_native_svg4 = __toESM(require("react-native-svg"));
var import_jsx_runtime4 = require("react/jsx-runtime");
var CollapseIconWrapper = import_react_native_theming.styled.View(
  ({ theme, isExpanded }) => ({
    width: 8,
    height: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.textMutedColor,
    transform: isExpanded ? "rotateZ(90deg)" : "none",
    transition: "transform .1s ease-out"
  })
);
var CollapseIcon = ({ isExpanded }) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(CollapseIconWrapper, { isExpanded, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(CollapseSVG, {}) });
function CollapseSVG(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_react_native_svg4.default, { width: 8, height: 8, fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_react_native_svg4.Path,
    {
      fill: "#73828C",
      d: "M1.896 7.146a.5.5 0 10.708.708l3.5-3.5a.5.5 0 000-.708l-3.5-3.5a.5.5 0 10-.708.708L5.043 4 1.896 7.146z"
    }
  ) });
}

// src/TreeNode.tsx
var import_react = require("react");
var import_polished = require("polished");
var import_react2 = __toESM(require("react"));
var import_jsx_runtime5 = require("react/jsx-runtime");
var BranchNodeText = import_react_native_theming2.styled.Text(({ theme }) => ({
  textAlign: "left",
  fontSize: theme.typography.size.s2,
  flexShrink: 1,
  color: theme.color.defaultText
}));
var BranchNode = import_react_native_theming2.styled.TouchableOpacity(({ depth = 0, isExpandable = false, theme }) => ({
  width: "100%",
  border: "none",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  alignSelf: "flex-start",
  paddingLeft: (isExpandable ? 8 : 22) + depth * 18,
  backgroundColor: "transparent",
  minHeight: 28,
  borderRadius: 4,
  gap: 6,
  paddingTop: 5,
  paddingBottom: 4,
  // will this actually do anything?
  "&:hover, &:focus": {
    backgroundColor: (0, import_polished.transparentize)(0.93, theme.color.secondary),
    outline: "none"
  }
}));
var LeafNode = import_react_native_theming2.styled.TouchableOpacity(
  ({ depth = 0, selected, theme }) => ({
    alignSelf: "flex-start",
    cursor: "pointer",
    color: "inherit",
    display: "flex",
    gap: 6,
    flexDirection: "row",
    alignItems: "flex-start",
    paddingLeft: 22 + depth * 18,
    paddingTop: 5,
    paddingBottom: 4,
    backgroundColor: selected ? theme.color.secondary : void 0,
    // not sure 👇
    width: "100%",
    borderRadius: 4,
    paddingRight: 20,
    minHeight: 28
  })
);
var LeafNodeText = import_react_native_theming2.styled.Text(({ theme, selected }) => ({
  fontSize: theme.typography.size.s2,
  flexShrink: 1,
  fontWeight: selected ? "bold" : "normal",
  color: selected ? theme.color.lightest : theme.color.defaultText
}));
var Wrapper = import_react_native_theming2.styled.View({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 6,
  marginTop: 2
});
var GroupNode = import_react2.default.memo(function GroupNode2({
  children,
  isExpanded = false,
  isExpandable = false,
  ...props
}) {
  const theme = (0, import_react_native_theming2.useTheme)();
  const color = (0, import_react.useMemo)(() => {
    return theme.base === "dark" ? theme.color.primary : theme.color.ultraviolet;
  }, [theme.base, theme.color.primary, theme.color.ultraviolet]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(BranchNode, { isExpandable, ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(Wrapper, { children: [
      isExpandable && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(CollapseIcon, { isExpanded }),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(GroupIcon, { width: 14, height: 14, color })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(BranchNodeText, { children })
  ] });
});
var ComponentNode = import_react2.default.memo(
  function ComponentNode2({ children, isExpanded, isExpandable, ...props }) {
    const theme = (0, import_react_native_theming2.useTheme)();
    const color = (0, import_react.useMemo)(() => {
      return theme.color.secondary;
    }, [theme.color.secondary]);
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(BranchNode, { isExpandable, ...props, children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(Wrapper, { children: [
        isExpandable && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(CollapseIcon, { isExpanded }),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(ComponentIcon, { width: 12, height: 12, color })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(BranchNodeText, { children })
    ] });
  }
);
var StoryNode = import_react2.default.memo(
  (0, import_react.forwardRef)(function StoryNode2({ children, ...props }, ref) {
    const theme = (0, import_react_native_theming2.useTheme)();
    const color = (0, import_react.useMemo)(() => {
      return props.selected ? theme.color.lightest : theme.color.seafoam;
    }, [props.selected, theme.color.lightest, theme.color.seafoam]);
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(LeafNode, { ...props, ref, children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(Wrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(StoryIcon, { width: 14, height: 14, color }) }),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(LeafNodeText, { selected: props.selected, children })
    ] });
  })
);
StoryNode.displayName = "StoryNode";

// src/Tree.tsx
var import_react_native_theming7 = require("@storybook/react-native-theming");
var import_react10 = __toESM(require("react"));

// src/Button.tsx
var import_react_native_theming3 = require("@storybook/react-native-theming");
var import_react3 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
var Button = (0, import_react3.forwardRef)(
  ({
    Icon,
    animation = "none",
    size = "small",
    variant = "outline",
    padding = "medium",
    disabled = false,
    active = false,
    onPress,
    children,
    text,
    ...props
  }, ref) => {
    const [isAnimating, setIsAnimating] = (0, import_react3.useState)(false);
    const handleClick = (event) => {
      if (onPress)
        onPress(event);
      if (animation === "none")
        return;
      setIsAnimating(true);
    };
    (0, import_react3.useEffect)(() => {
      const timer = setTimeout(() => {
        if (isAnimating)
          setIsAnimating(false);
      }, 1e3);
      return () => clearTimeout(timer);
    }, [isAnimating]);
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
      StyledButton,
      {
        ref,
        variant,
        size,
        padding,
        disabled,
        active,
        animating: isAnimating,
        animation,
        onPress: handleClick,
        ...props,
        children: [
          Icon && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ButtonIcon, { Icon, variant, active }),
          text && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ButtonText, { variant, active, children: text }),
          children
        ]
      }
    );
  }
);
Button.displayName = "Button";
var StyledButton = import_react_native_theming3.styled.TouchableOpacity(({ theme, variant, size, disabled, active, padding }) => ({
  border: 0,
  // cursor: disabled ? 'not-allowed' : 'pointer',
  display: "flex",
  flexDirection: "row",
  gap: 6,
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  paddingHorizontal: (() => {
    if (padding === "small" && size === "small")
      return 7;
    if (padding === "small" && size === "medium")
      return 9;
    if (size === "small")
      return 10;
    if (size === "medium")
      return 12;
    return 0;
  })(),
  paddingVertical: 0,
  height: size === "small" ? 28 : 32,
  position: "relative",
  transitionProperty: "background, box-shadow",
  transitionDuration: "150ms",
  transitionTimingFunction: "ease-out",
  whiteSpace: "nowrap",
  userSelect: "none",
  opacity: disabled ? 0.5 : 1,
  margin: 0,
  backgroundColor: (() => {
    if (variant === "solid")
      return theme.color.secondary;
    if (variant === "outline")
      return theme.button.background;
    if (variant === "ghost" && active)
      return theme.background.hoverable;
    return "transparent";
  })(),
  boxShadow: variant === "outline" ? `${theme.button.border} 0 0 0 1px inset` : "none",
  borderRadius: theme.input.borderRadius,
  // Making sure that the button never shrinks below its minimum size
  flexShrink: 0
}));
var ButtonText = import_react_native_theming3.styled.Text(({ theme, variant, active }) => ({
  color: (() => {
    if (variant === "solid")
      return theme.color.lightest;
    if (variant === "outline")
      return theme.input.color;
    if (variant === "ghost" && active)
      return theme.color.secondary;
    if (variant === "ghost")
      return theme.color.mediumdark;
    return theme.input.color;
  })(),
  flexDirection: "row",
  gap: 6,
  textAlign: "center",
  fontSize: theme.typography.size.s1,
  fontWeight: theme.typography.weight.bold
}));
var ButtonIcon = ({
  Icon,
  active,
  variant
}) => {
  const theme = (0, import_react_native_theming3.useTheme)();
  const color = (0, import_react3.useMemo)(() => {
    if (variant === "solid")
      return theme.color.lightest;
    if (variant === "outline")
      return theme.input.color;
    if (variant === "ghost" && active)
      return theme.color.secondary;
    if (variant === "ghost")
      return theme.color.mediumdark;
    return theme.input.color;
  }, [
    active,
    theme.color.lightest,
    theme.color.mediumdark,
    theme.color.secondary,
    theme.input.color,
    variant
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(Icon, { color });
};

// src/IconButton.tsx
var import_react4 = require("react");
var import_jsx_runtime7 = require("react/jsx-runtime");
var IconButton = (0, import_react4.forwardRef)(
  ({ padding = "small", variant = "ghost", ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(Button, { padding, variant, ref, ...props });
  }
);
IconButton.displayName = "IconButton";

// src/icon/CollapseAllIcon.tsx
var import_react_native_svg5 = require("react-native-svg");
var import_react_native_theming4 = require("@storybook/react-native-theming");
var import_react5 = require("react");
var import_jsx_runtime8 = require("react/jsx-runtime");
var CollapseAllIcon = ({
  color,
  //= '#2E3438',
  width = 14,
  height = 14,
  ...props
}) => {
  const theme = (0, import_react_native_theming4.useTheme)();
  const fillColor = (0, import_react5.useMemo)(() => {
    return color ?? theme.color.defaultText;
  }, [color, theme.color.defaultText]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_react_native_svg5.Svg, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    import_react_native_svg5.Path,
    {
      d: "M3.354.146a.5.5 0 10-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 00-.708-.708L7 3.793 3.354.146zM6.646 9.146a.5.5 0 01.708 0l4 4a.5.5 0 01-.708.708L7 10.207l-3.646 3.647a.5.5 0 01-.708-.708l4-4z",
      fill: fillColor
    }
  ) });
};

// src/icon/ExpandAllIcon.tsx
var import_react_native_svg6 = require("react-native-svg");
var import_react_native_theming5 = require("@storybook/react-native-theming");
var import_react6 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
var ExpandAllIcon = ({
  color,
  //= '#2E3438',
  width = 14,
  height = 14,
  ...props
}) => {
  const theme = (0, import_react_native_theming5.useTheme)();
  const fillColor = (0, import_react6.useMemo)(() => {
    return color ?? theme.color.defaultText;
  }, [color, theme.color.defaultText]);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_react_native_svg6.Svg, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    import_react_native_svg6.Path,
    {
      d: "M7.354.146l4 4a.5.5 0 01-.708.708L7 1.207 3.354 4.854a.5.5 0 11-.708-.708l4-4a.5.5 0 01.708 0zM11.354 9.146a.5.5 0 010 .708l-4 4a.5.5 0 01-.708 0l-4-4a.5.5 0 11.708-.708L7 12.793l3.646-3.647a.5.5 0 01.708 0z",
      fill: fillColor
    }
  ) });
};

// src/hooks/useExpanded.ts
var import_react7 = require("react");

// src/util/tree.ts
var import_memoizerific = __toESM(require("memoizerific"));

// src/constants.ts
var BREAKPOINT = 1e3;
var MEDIA_DESKTOP_BREAKPOINT = `@media (min-width: ${BREAKPOINT}px)`;
var DEFAULT_REF_ID = "storybook_internal";

// src/util/tree.ts
var createId = (itemId, refId) => !refId || refId === DEFAULT_REF_ID ? itemId : `${refId}_${itemId}`;
var get = (0, import_memoizerific.default)(1e3)((id, dataset) => dataset[id]);
var getParent = (0, import_memoizerific.default)(1e3)((id, dataset) => {
  const item = get(id, dataset);
  return item && item.type !== "root" ? get(item.parent, dataset) : void 0;
});
var getParents = (0, import_memoizerific.default)(1e3)((id, dataset) => {
  const parent = getParent(id, dataset);
  return parent ? [parent, ...getParents(parent.id, dataset)] : [];
});
var getAncestorIds = (0, import_memoizerific.default)(1e3)(
  (data, id) => getParents(id, data).map((item) => item.id)
);
var getDescendantIds = (0, import_memoizerific.default)(1e3)(
  (data, id, skipLeafs) => {
    const entry = data[id];
    const children = entry.type === "story" || entry.type === "docs" ? [] : entry.children;
    return children.reduce((acc, childId) => {
      const child = data[childId];
      if (!child || skipLeafs && (child.type === "story" || child.type === "docs"))
        return acc;
      acc.push(childId, ...getDescendantIds(data, childId, skipLeafs));
      return acc;
    }, []);
  }
);
function getPath(item, ref) {
  const parent = item.type !== "root" && item.parent ? ref.index[item.parent] : null;
  if (parent)
    return [...getPath(parent, ref), parent.name];
  return ref.id === DEFAULT_REF_ID ? [] : [ref.title || ref.id];
}
var searchItem = (item, ref) => {
  return { ...item, refId: ref.id, path: getPath(item, ref) };
};
var getStateType = (isLoading, isAuthRequired, isError, isEmpty) => {
  switch (true) {
    case isAuthRequired:
      return "auth";
    case isError:
      return "error";
    case isLoading:
      return "loading";
    case isEmpty:
      return "empty";
    default:
      return "ready";
  }
};
var removeNoiseFromName = (storyName) => storyName.replaceAll(/(\s|-|_)/gi, "");
var isStoryHoistable = (storyName, componentName) => removeNoiseFromName(storyName) === removeNoiseFromName(componentName);

// src/hooks/useExpanded.ts
var initializeExpanded = ({
  initialExpanded,
  rootIds
}) => {
  const highlightedAncestors = [];
  return [...rootIds, ...highlightedAncestors].reduce(
    (acc, id) => Object.assign(acc, { [id]: id in initialExpanded ? initialExpanded[id] : true }),
    {}
  );
};
var useExpanded = ({
  refId,
  data,
  initialExpanded,
  rootIds,
  selectedStoryId
}) => {
  const [expanded, setExpanded] = (0, import_react7.useReducer)(
    (state, { ids, value }) => ids.reduce((acc, id) => Object.assign(acc, { [id]: value }), { ...state }),
    { refId, data, rootIds, initialExpanded },
    initializeExpanded
  );
  const updateExpanded = (0, import_react7.useCallback)(({ ids, value }) => {
    setExpanded({ ids, value });
  }, []);
  (0, import_react7.useEffect)(() => {
    setExpanded({ ids: getAncestorIds(data, selectedStoryId), value: true });
  }, [data, selectedStoryId]);
  return [expanded, updateExpanded];
};

// src/util/status.tsx
var import_react8 = require("react");
var import_react_native_theming6 = require("@storybook/react-native-theming");
var import_react_native_svg7 = __toESM(require("react-native-svg"));
var import_jsx_runtime10 = require("react/jsx-runtime");
function CircleIcon({ height = 14, width = 14, color, ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_react_native_svg7.default, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_react_native_svg7.Path, { d: "M14 7A7 7 0 110 7a7 7 0 0114 0z", fill: color }) });
}
function SmallIcons(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(CircleIcon, { width: 6, height: 6, ...props });
}
function LoadingIcons(props) {
  const theme = (0, import_react_native_theming6.useTheme)();
  const color = (0, import_react8.useMemo)(() => {
    return theme.base === "light" ? theme.color.mediumdark : theme.color.darker;
  }, [theme.base, theme.color.darker, theme.color.mediumdark]);
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(SmallIcons, { color, ...props });
}
var statusPriority = ["unknown", "pending", "success", "warn", "error"];
var statusMapping = {
  unknown: [null, null],
  pending: [/* @__PURE__ */ (0, import_jsx_runtime10.jsx)(LoadingIcons, {}, "icon"), "currentColor"],
  success: [/* @__PURE__ */ (0, import_jsx_runtime10.jsx)(SmallIcons, { color: "green" }, "icon"), "currentColor"],
  warn: [/* @__PURE__ */ (0, import_jsx_runtime10.jsx)(SmallIcons, { color: "orange" }, "icon"), "#A15C20"],
  error: [/* @__PURE__ */ (0, import_jsx_runtime10.jsx)(SmallIcons, { color: "red" }, "icon"), "brown"]
};
var getHighestStatus = (statuses) => {
  return statusPriority.reduce(
    (acc, status) => statuses.includes(status) ? status : acc,
    "unknown"
  );
};
function getGroupStatus(collapsedData, status) {
  return Object.values(collapsedData).reduce((acc, item) => {
    if (item.type === "group" || item.type === "component") {
      const leafs = getDescendantIds(collapsedData, item.id, false).map((id) => collapsedData[id]).filter((i) => i.type === "story");
      const combinedStatus = getHighestStatus(
        leafs.flatMap((story) => Object.values(status?.[story.id] || {})).map((s) => s.status)
      );
      if (combinedStatus) {
        acc[item.id] = combinedStatus;
      }
    }
    return acc;
  }, {});
}

// src/SelectedNodeProvider.tsx
var import_react9 = require("react");
var import_jsx_runtime11 = require("react/jsx-runtime");
var SelectedNodeContext = (0, import_react9.createContext)({
  nodeRef: { current: null },
  setNodeRef: () => {
  },
  scrollToSelectedNode: () => {
  },
  scrollRef: null
});
var SelectedNodeProvider = ({ children }) => {
  const nodeRef = (0, import_react9.useRef)(null);
  const setNodeRef = (0, import_react9.useCallback)((node) => {
    nodeRef.current = node;
  }, []);
  const scrollRef = (0, import_react9.useRef)(null);
  const scrollToSelectedNode = (0, import_react9.useCallback)(() => {
    setTimeout(() => {
      if (nodeRef?.current && scrollRef?.current) {
        try {
          nodeRef.current.measureLayout?.(scrollRef.current, (_x, y) => {
            scrollRef.current?.scrollTo({ y: y - 100, animated: true });
          });
        } catch (error) {
        }
      }
    }, 500);
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    SelectedNodeContext.Provider,
    {
      value: {
        nodeRef,
        setNodeRef,
        scrollToSelectedNode,
        scrollRef
      },
      children
    }
  );
};
var useSelectedNode = () => (0, import_react9.useContext)(SelectedNodeContext);

// src/Tree.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var TextItem = import_react_native_theming7.styled.Text(({ theme }) => ({
  color: theme.color.defaultText
}));
var Node = import_react10.default.memo(function Node2({
  item,
  refId,
  isOrphan,
  isDisplayed,
  isSelected,
  isFullyExpanded,
  color: _2,
  setFullyExpanded,
  isExpanded,
  setExpanded,
  onSelectStoryId
}) {
  const { setNodeRef } = useSelectedNode();
  const setRef = (0, import_react10.useCallback)(
    (node) => {
      if (isSelected && node) {
        setNodeRef(node);
      }
    },
    [isSelected, setNodeRef]
  );
  if (!isDisplayed) {
    return null;
  }
  const id = createId(item.id, refId);
  if (item.type === "story") {
    return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(LeafNodeStyleWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
      StoryNode,
      {
        ref: setRef,
        selected: isSelected,
        id,
        depth: isOrphan ? item.depth : item.depth - 1,
        onPress: () => {
          onSelectStoryId(item.id);
        },
        children: item.renderLabel?.(item) || item.name
      },
      id
    ) });
  }
  if (item.type === "root") {
    return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(RootNode, { id, children: [
      /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(
        CollapseButton,
        {
          "data-action": "collapse-root",
          onPress: (event) => {
            event.preventDefault();
            setExpanded({ ids: [item.id], value: !isExpanded });
          },
          "aria-expanded": isExpanded,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(CollapseIcon, { isExpanded }),
            /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(TextItem, { children: item.renderLabel?.(item, {}) || item.name })
          ]
        }
      ),
      isExpanded && /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
        IconButton,
        {
          "aria-label": isFullyExpanded ? "Expand" : "Collapse",
          "data-action": "expand-all",
          "data-expanded": isFullyExpanded,
          onPress: (event) => {
            event.preventDefault();
            setFullyExpanded();
          },
          children: isFullyExpanded ? /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(CollapseAllIcon, {}) : /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(ExpandAllIcon, {})
        }
      )
    ] }, id);
  }
  if (item.type === "component" || item.type === "group") {
    const BranchNode2 = item.type === "component" ? ComponentNode : GroupNode;
    return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
      BranchNode2,
      {
        id,
        "aria-controls": item.children && item.children[0],
        "aria-expanded": isExpanded,
        depth: isOrphan ? item.depth : item.depth - 1,
        isComponent: item.type === "component",
        isExpandable: item.children && item.children.length > 0,
        isExpanded,
        onPress: (event) => {
          event.preventDefault();
          setExpanded({ ids: [item.id], value: !isExpanded });
        },
        children: item.renderLabel?.(item) || item.name
      },
      id
    );
  }
  return null;
});
var LeafNodeStyleWrapper = import_react_native_theming7.styled.View(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  paddingRight: 20,
  color: theme.color.defaultText,
  backgroundColor: "transparent",
  minHeight: 28,
  borderRadius: 4
}));
var RootNode = import_react_native_theming7.styled.View(({}) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 16,
  marginBottom: 4,
  minHeight: 28
}));
var RootNodeText = import_react_native_theming7.styled.Text(({ theme }) => ({
  fontSize: theme.typography.size.s1 - 1,
  fontWeight: theme.typography.weight.bold,
  color: theme.textMutedColor,
  lineHeight: 16,
  letterSpacing: 2.5,
  textTransform: "uppercase"
}));
var CollapseButton = import_react_native_theming7.styled.TouchableOpacity(({}) => ({
  display: "flex",
  flexDirection: "row",
  paddingVertical: 0,
  paddingHorizontal: 8,
  borderRadius: 4,
  gap: 6,
  alignItems: "center",
  cursor: "pointer",
  height: 28
}));
var Tree = import_react10.default.memo(function Tree2({ isMain, refId, data, status, docsMode, selectedStoryId, onSelectStoryId }) {
  const containerRef = (0, import_react10.useRef)(null);
  const [rootIds, orphanIds, initialExpanded] = (0, import_react10.useMemo)(
    () => Object.keys(data).reduce(
      (acc, id) => {
        const item = data[id];
        if (item.type === "root")
          acc[0].push(id);
        else if (!item.parent)
          acc[1].push(id);
        if (item.type === "root" && item.startCollapsed)
          acc[2][id] = false;
        return acc;
      },
      [[], [], {}]
    ),
    [data]
  );
  const { expandableDescendants } = (0, import_react10.useMemo)(() => {
    return [...orphanIds, ...rootIds].reduce(
      (acc, nodeId) => {
        acc.expandableDescendants[nodeId] = getDescendantIds(data, nodeId, false).filter(
          (d) => !["story", "docs"].includes(data[d].type)
        );
        return acc;
      },
      { orphansFirst: [], expandableDescendants: {} }
    );
  }, [data, rootIds, orphanIds]);
  const singleStoryComponentIds = (0, import_react10.useMemo)(() => {
    return Object.keys(data).filter((id) => {
      const entry = data[id];
      if (entry.type !== "component")
        return false;
      const { children = [], name } = entry;
      if (children.length !== 1)
        return false;
      const onlyChild = data[children[0]];
      if (onlyChild.type === "docs")
        return true;
      if (onlyChild.type === "story")
        return isStoryHoistable(onlyChild.name, name);
      return false;
    });
  }, [data]);
  const collapsedItems = (0, import_react10.useMemo)(
    () => Object.keys(data).filter((id) => !singleStoryComponentIds.includes(id)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [singleStoryComponentIds]
  );
  const collapsedData = (0, import_react10.useMemo)(() => {
    return singleStoryComponentIds.reduce(
      (acc, id) => {
        const { children, parent, name } = data[id];
        const [childId] = children;
        if (parent) {
          const siblings = [...data[parent].children];
          siblings[siblings.indexOf(id)] = childId;
          acc[parent] = { ...data[parent], children: siblings };
        }
        acc[childId] = {
          ...data[childId],
          name,
          parent,
          depth: data[childId].depth - 1
        };
        return acc;
      },
      { ...data }
    );
  }, [data]);
  const ancestry = (0, import_react10.useMemo)(() => {
    return collapsedItems.reduce(
      (acc, id) => Object.assign(acc, { [id]: getAncestorIds(collapsedData, id) }),
      {}
    );
  }, [collapsedItems, collapsedData]);
  const [expanded, setExpanded] = useExpanded({
    refId,
    data: collapsedData,
    initialExpanded,
    rootIds,
    selectedStoryId,
    onSelectStoryId
  });
  const groupStatus = (0, import_react10.useMemo)(() => getGroupStatus(collapsedData, status), [collapsedData, status]);
  const treeItems = (0, import_react10.useMemo)(() => {
    return collapsedItems.map((itemId) => {
      const item = collapsedData[itemId];
      const id = createId(itemId, refId);
      if (item.type === "root") {
        const descendants = expandableDescendants[item.id];
        const isFullyExpanded = descendants.every((d) => expanded[d]);
        return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
          Root,
          {
            item,
            refId,
            isOrphan: false,
            isDisplayed: true,
            isSelected: selectedStoryId === itemId,
            isExpanded: !!expanded[itemId],
            setExpanded,
            isFullyExpanded,
            expandableDescendants: descendants,
            onSelectStoryId,
            docsMode: false,
            color: "",
            status: {}
          },
          id
        );
      }
      const isDisplayed = !item.parent || ancestry[itemId].every((a) => expanded[a]);
      const color = groupStatus[itemId] ? statusMapping[groupStatus[itemId]][1] : null;
      return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
        Node,
        {
          item,
          status: status?.[itemId],
          refId,
          color,
          docsMode,
          isOrphan: orphanIds.some((oid) => itemId === oid || itemId.startsWith(`${oid}-`)),
          isDisplayed,
          isSelected: selectedStoryId === itemId,
          isExpanded: !!expanded[itemId],
          setExpanded,
          onSelectStoryId
        },
        id
      );
    });
  }, [
    ancestry,
    collapsedData,
    collapsedItems,
    docsMode,
    expandableDescendants,
    expanded,
    groupStatus,
    onSelectStoryId,
    orphanIds,
    refId,
    selectedStoryId,
    setExpanded,
    status
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(Container, { ref: containerRef, hasOrphans: isMain && orphanIds.length > 0, children: treeItems });
});
var Container = import_react_native_theming7.styled.View((props) => ({
  marginTop: props.hasOrphans ? 20 : 0,
  marginBottom: 20
}));
var Root = import_react10.default.memo(function Root2({
  setExpanded,
  isFullyExpanded,
  expandableDescendants,
  ...props
}) {
  const setFullyExpanded = (0, import_react10.useCallback)(
    () => setExpanded({ ids: expandableDescendants, value: !isFullyExpanded }),
    [setExpanded, isFullyExpanded, expandableDescendants]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    Node,
    {
      ...props,
      setExpanded,
      isFullyExpanded,
      setFullyExpanded
    }
  );
});

// src/LayoutProvider.tsx
var import_react11 = require("react");
var import_react_native = require("react-native");
var import_jsx_runtime13 = require("react/jsx-runtime");
var LayoutContext = (0, import_react11.createContext)({
  isDesktop: false,
  isMobile: true
});
var LayoutProvider = ({ children }) => {
  const { width } = (0, import_react_native.useWindowDimensions)();
  const isDesktop = width >= BREAKPOINT;
  const isMobile = !isDesktop;
  const contextValue = (0, import_react11.useMemo)(
    () => ({
      isDesktop,
      isMobile
    }),
    [isDesktop, isMobile]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(LayoutContext.Provider, { value: contextValue, children });
};
var useLayout = () => (0, import_react11.useContext)(LayoutContext);

// src/Explorer.tsx
var import_react13 = __toESM(require("react"));

// src/Refs.tsx
var import_react12 = __toESM(require("react"));
var import_react_native_theming8 = require("@storybook/react-native-theming");
var import_jsx_runtime14 = require("react/jsx-runtime");
var Wrapper2 = import_react_native_theming8.styled.View(({}) => ({
  position: "relative"
}));
var Ref = import_react12.default.memo(function Ref2(props) {
  const {
    index,
    id: refId,
    title = refId,
    isLoading: isLoadingMain,
    isBrowsing,
    selectedStoryId,
    loginUrl,
    type,
    expanded = true,
    indexError,
    previewInitialized,
    setSelection
  } = props;
  const length = (0, import_react12.useMemo)(() => index ? Object.keys(index).length : 0, [index]);
  const isLoadingInjected = type === "auto-inject" && !previewInitialized || type === "server-checked";
  const isLoading = isLoadingMain || isLoadingInjected || type === "unknown";
  const isError = !!indexError;
  const isEmpty = !isLoading && length === 0;
  const isAuthRequired = !!loginUrl && length === 0;
  const state = getStateType(isLoading, isAuthRequired, isError, isEmpty);
  const [isExpanded, setExpanded] = (0, import_react12.useState)(expanded);
  (0, import_react12.useEffect)(() => {
    if (index && selectedStoryId && index[selectedStoryId]) {
      setExpanded(true);
    }
  }, [setExpanded, index, selectedStoryId]);
  const onSelectStoryId = (0, import_react12.useCallback)(
    (storyId) => {
      setSelection({ refId, storyId });
    },
    [refId, setSelection]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_jsx_runtime14.Fragment, { children: isExpanded && /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(Wrapper2, { "data-title": title, isMain: true, children: state === "ready" && /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
    Tree,
    {
      status: props.status,
      isBrowsing,
      isMain: true,
      refId,
      data: index,
      docsMode: false,
      selectedStoryId,
      onSelectStoryId
    }
  ) }) });
});

// src/Explorer.tsx
var import_react_native2 = require("react-native");
var import_jsx_runtime15 = require("react/jsx-runtime");
var import_react14 = require("react");
var Explorer = import_react13.default.memo(function Explorer2({
  isLoading,
  isBrowsing,
  dataset,
  selected,
  setSelection
}) {
  const containerRef = (0, import_react13.useRef)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(import_react_native2.View, { ref: containerRef, id: "storybook-explorer-tree", children: dataset.entries.map(([refId, ref]) => /* @__PURE__ */ (0, import_react14.createElement)(
    Ref,
    {
      ...ref,
      key: refId,
      isLoading,
      isBrowsing,
      selectedStoryId: selected?.refId === ref.id ? selected.storyId : null,
      setSelection
    }
  )) });
});

// src/Sidebar.tsx
var import_react19 = __toESM(require("react"));
var import_react_native_theming12 = require("@storybook/react-native-theming");

// src/Search.tsx
var import_bottom_sheet = require("@gorhom/bottom-sheet");
var import_react_native_theming10 = require("@storybook/react-native-theming");
var import_fuse = __toESM(require("fuse.js"));
var import_react15 = __toESM(require("react"));
var import_react_native3 = require("react-native");

// src/icon/CloseIcon.tsx
var import_react_native_svg8 = require("react-native-svg");
var import_jsx_runtime16 = require("react/jsx-runtime");
var CloseIcon = ({
  color = "currentColor",
  width = 14,
  height = 14,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(import_react_native_svg8.Svg, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
      import_react_native_svg8.Path,
      {
        d: "M9.854 4.146a.5.5 0 010 .708L7.707 7l2.147 2.146a.5.5 0 01-.708.708L7 7.707 4.854 9.854a.5.5 0 01-.708-.708L6.293 7 4.146 4.854a.5.5 0 11.708-.708L7 6.293l2.146-2.147a.5.5 0 01.708 0z",
        fill: color
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
      import_react_native_svg8.Path,
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14A7 7 0 107 0a7 7 0 000 14zm0-1A6 6 0 107 1a6 6 0 000 12z",
        fill: color
      }
    )
  ] });
};

// src/icon/SearchIcon.tsx
var import_react_native_svg9 = require("react-native-svg");
var import_react_native_theming9 = require("@storybook/react-native-theming");
var import_jsx_runtime17 = require("react/jsx-runtime");
var SearchIcon = ({ width = 14, height = 14, ...props }) => {
  const theme = (0, import_react_native_theming9.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_react_native_svg9.Svg, { width, height, viewBox: "0 0 14 14", fill: theme.color.dark, ...props, children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    import_react_native_svg9.Path,
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.544 10.206a5.5 5.5 0 11.662-.662.5.5 0 01.148.102l3 3a.5.5 0 01-.708.708l-3-3a.5.5 0 01-.102-.148zM10.5 6a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
    }
  ) });
};

// src/types.ts
function isExpandType(x2) {
  return !!(x2 && x2.showAll);
}

// src/Search.tsx
var import_jsx_runtime18 = require("react/jsx-runtime");
var DEFAULT_MAX_SEARCH_RESULTS = 50;
var options = {
  shouldSort: true,
  tokenize: true,
  findAllMatches: true,
  includeScore: true,
  includeMatches: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    { name: "name", weight: 0.7 },
    { name: "path", weight: 0.3 }
  ]
};
var SearchIconWrapper = import_react_native_theming10.styled.View({
  position: "absolute",
  top: 0,
  left: 8,
  zIndex: 1,
  pointerEvents: "none",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  height: "100%"
});
var SearchField = import_react_native_theming10.styled.View({
  display: "flex",
  flexDirection: "column",
  position: "relative"
});
var BottomSheetInput = (0, import_react_native_theming10.styled)(import_bottom_sheet.BottomSheetTextInput)(({ theme }) => ({
  height: 32,
  paddingLeft: 28,
  paddingRight: 28,
  paddingTop: import_react_native3.Platform.OS === "android" ? 0 : void 0,
  paddingBottom: import_react_native3.Platform.OS === "android" ? 0 : void 0,
  borderWidth: 1,
  borderColor: theme.appBorderColor,
  backgroundColor: "transparent",
  borderRadius: 4,
  fontSize: theme.typography.size.s1 + 1,
  color: theme.color.defaultText,
  width: "100%"
}));
var Input = (0, import_react_native_theming10.styled)(import_react_native3.TextInput)(({ theme }) => ({
  height: 32,
  paddingLeft: 28,
  paddingRight: 28,
  borderWidth: 1,
  borderColor: theme.appBorderColor,
  backgroundColor: "transparent",
  borderRadius: 6,
  fontSize: theme.typography.size.s1 + 1,
  color: theme.color.defaultText,
  width: "100%"
}));
var ClearIcon = import_react_native_theming10.styled.TouchableOpacity(({ theme }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 8,
  zIndex: 1,
  color: theme.textMutedColor,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%"
}));
var Search = import_react15.default.memo(function Search2({ children, dataset, setSelection, getLastViewed, initialQuery = "" }) {
  const inputRef = (0, import_react15.useRef)(null);
  const [inputValue, setInputValue] = (0, import_react15.useState)(initialQuery);
  const [isOpen, setIsOpen] = (0, import_react15.useState)(false);
  const [allComponents, showAllComponents] = (0, import_react15.useState)(false);
  const { isMobile } = useLayout();
  const { scrollToSelectedNode } = useSelectedNode();
  const selectStory = (0, import_react15.useCallback)(
    (id, refId) => {
      setSelection({ storyId: id, refId });
      inputRef.current?.blur();
      setIsOpen(false);
      showAllComponents(false);
      scrollToSelectedNode();
    },
    [scrollToSelectedNode, setSelection]
  );
  const getItemProps = (0, import_react15.useCallback)(
    ({ item: result }) => {
      return {
        icon: result?.item?.type === "component" ? "component" : "story",
        result,
        onPress: () => {
          if (result?.item?.type === "story") {
            selectStory(result.item.id, result.item.refId);
          } else if (result?.item?.type === "component") {
            selectStory(result.item.children[0], result.item.refId);
          } else if (isExpandType(result) && result.showAll) {
            result.showAll();
          }
        },
        score: result.score,
        refIndex: result.refIndex,
        item: result.item,
        matches: result.matches,
        isHighlighted: false
      };
    },
    [selectStory]
  );
  const makeFuse = (0, import_react15.useCallback)(() => {
    const list = dataset.entries.reduce((acc, [refId, { index, status }]) => {
      const groupStatus = getGroupStatus(index || {}, status);
      if (index) {
        acc.push(
          ...Object.values(index).map((item) => {
            const statusValue = status && status[item.id] ? getHighestStatus(Object.values(status[item.id] || {}).map((s) => s.status)) : null;
            return {
              ...searchItem(item, dataset.hash[refId]),
              status: statusValue || groupStatus[item.id] || null
            };
          })
        );
      }
      return acc;
    }, []);
    return new import_fuse.default(list, options);
  }, [dataset]);
  const getResults = (0, import_react15.useCallback)(
    (input2) => {
      const fuse = makeFuse();
      if (!input2)
        return [];
      let results2 = [];
      const resultIds = /* @__PURE__ */ new Set();
      const distinctResults = fuse.search(input2).filter(({ item }) => {
        if (!(item.type === "component" || item.type === "docs" || item.type === "story") || resultIds.has(item.parent)) {
          return false;
        }
        resultIds.add(item.id);
        return true;
      });
      if (distinctResults.length) {
        results2 = distinctResults.slice(0, allComponents ? 1e3 : DEFAULT_MAX_SEARCH_RESULTS);
        if (distinctResults.length > DEFAULT_MAX_SEARCH_RESULTS && !allComponents) {
          results2.push({
            showAll: () => showAllComponents(true),
            totalCount: distinctResults.length,
            moreCount: distinctResults.length - DEFAULT_MAX_SEARCH_RESULTS
          });
        }
      }
      const lastViewed = !input2 && getLastViewed();
      if (lastViewed && lastViewed.length) {
        results2 = lastViewed.reduce((acc, { storyId, refId }) => {
          const data = dataset.hash[refId];
          if (data && data.index && data.index[storyId]) {
            const story = data.index[storyId];
            const item = story.type === "story" ? data.index[story.parent] : story;
            if (!acc.some((res) => res.item.refId === refId && res.item.id === item.id)) {
              acc.push({ item: searchItem(item, dataset.hash[refId]), matches: [], score: 0 });
            }
          }
          return acc;
        }, []);
      }
      return results2;
    },
    [allComponents, dataset.hash, getLastViewed, makeFuse]
  );
  const deferredQuery = (0, import_react15.useDeferredValue)(inputValue);
  const input = deferredQuery ? deferredQuery.trim() : "";
  const results = input ? getResults(input) : [];
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(import_react_native3.View, { style: { flex: 1 }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(SearchField, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(SearchIconWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(SearchIcon, {}) }),
      isMobile ? /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        BottomSheetInput,
        {
          ref: inputRef,
          onChangeText: setInputValue,
          onFocus: () => setIsOpen(true),
          onBlur: () => setIsOpen(false)
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(Input, { ref: inputRef, onChangeText: setInputValue, onFocus: () => setIsOpen(true) }),
      isOpen && /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ClearIcon,
        {
          onPress: () => {
            setInputValue("");
            inputRef.current.clear();
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(CloseIcon, {})
        }
      )
    ] }),
    children({
      query: input,
      results,
      isBrowsing: !isOpen || !inputValue.length,
      closeMenu: () => {
      },
      getItemProps,
      highlightedIndex: null
    })
  ] });
});

// src/SearchResults.tsx
var import_react_native_theming11 = require("@storybook/react-native-theming");
var import_react16 = __toESM(require("react"));
var import_polished2 = require("polished");
var import_react_native4 = require("react-native");
var import_jsx_runtime19 = require("react/jsx-runtime");
var import_react17 = require("react");
var ResultsList = import_react_native_theming11.styled.View({
  margin: 0,
  padding: 0,
  marginTop: 8
});
var ResultRow = import_react_native_theming11.styled.TouchableOpacity(
  ({ theme, isHighlighted }) => ({
    width: "100%",
    border: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    textAlign: "left",
    color: theme.color.defaultText,
    fontSize: theme.typography.size.s2,
    backgroundColor: isHighlighted ? theme.background.hoverable : "transparent",
    minHeight: 28,
    borderRadius: 4,
    gap: 6,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 8,
    paddingRight: 8,
    "&:hover, &:focus": {
      backgroundColor: (0, import_polished2.transparentize)(0.93, theme.color.secondary),
      outline: "none"
    }
  })
);
var IconWrapper = import_react_native_theming11.styled.View({
  marginTop: 2
});
var ResultRowContent = import_react_native_theming11.styled.View(() => ({
  display: "flex",
  flexDirection: "column"
}));
var NoResults = import_react_native_theming11.styled.View(({ theme }) => ({
  marginTop: 20,
  textAlign: "center",
  fontSize: theme.typography.size.s2,
  lineHeight: 18,
  color: theme.color.defaultText
}));
var Mark = import_react_native_theming11.styled.Text(({ theme }) => ({
  backgroundColor: "transparent",
  color: theme.color.secondary
}));
var MoreWrapper = import_react_native_theming11.styled.View({
  marginTop: 8
});
var RecentlyOpenedTitle = import_react_native_theming11.styled.View(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  fontSize: theme.typography.size.s1 - 1,
  fontWeight: theme.typography.weight.bold,
  minHeight: 28,
  // letterSpacing: '0.16em', <-- todo
  textTransform: "uppercase",
  color: theme.textMutedColor,
  marginTop: 16,
  marginBottom: 4,
  alignItems: "center"
}));
var Highlight = import_react16.default.memo(
  function Highlight2({ children, match }) {
    if (!match)
      return children;
    const { value, indices } = match;
    const { nodes: result } = indices.reduce(
      ({ cursor, nodes }, [start, end], index, { length }) => {
        nodes.push(/* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { children: value.slice(cursor, start) }, `text-${index}`));
        nodes.push(/* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Mark, { children: value.slice(start, end + 1) }, `mark-${index}`));
        if (index === length - 1) {
          nodes.push(/* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { children: value.slice(end + 1) }, `last-${index}`));
        }
        return { cursor: end + 1, nodes };
      },
      { cursor: 0, nodes: [] }
    );
    return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { children: result }, `end-${match.key}`);
  }
);
var Title = import_react_native_theming11.styled.Text(({ theme }) => ({
  justifyContent: "flex-start",
  color: theme.textMutedColor,
  fontSize: theme.typography.size.s2
}));
var Path10 = import_react_native_theming11.styled.View(({ theme }) => ({
  justifyContent: "flex-start",
  marginVertical: 2,
  color: theme.textMutedColor,
  fontSize: theme.typography.size.s1 - 1,
  flexDirection: "row"
}));
var PathText = import_react_native_theming11.styled.Text(({ theme }) => ({
  fontSize: theme.typography.size.s1 - 1,
  color: theme.textMutedColor
}));
var Result = import_react16.default.memo(function Result2({
  item,
  matches,
  icon: _icon,
  onPress,
  ...props
}) {
  const press = (0, import_react16.useCallback)(
    (event) => {
      event.preventDefault();
      onPress?.(event);
    },
    [onPress]
  );
  const nameMatch = matches.find((match) => match.key === "name");
  const pathMatches = matches.filter((match) => match.key === "path");
  const [i] = item.status ? statusMapping[item.status] : [];
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(ResultRow, { ...props, onPress: press, children: [
    /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(IconWrapper, { children: [
      item.type === "component" && /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(ComponentIcon, { width: "14", height: "14" }),
      item.type === "story" && /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(StoryIcon, { width: "14", height: "14" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(ResultRowContent, { testID: "search-result-item--label", children: [
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Title, { children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Highlight, { match: nameMatch, children: item.name }, "search-result-item--label-highlight") }),
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Path10, { children: item.path.map((group, index) => {
        const pathSeparator = index === item.path.length - 1 ? "" : "/";
        return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(import_react_native4.View, { style: { flexShrink: 1 }, children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(PathText, { children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          Highlight,
          {
            match: pathMatches.find((match) => match.refIndex === index),
            children: `${group}${pathSeparator}`
          }
        ) }) }, index);
      }) })
    ] }),
    item.status ? i : null
  ] });
});
var Text = import_react_native_theming11.styled.Text(({ theme }) => ({
  color: theme.color.defaultText
}));
var SearchResults = import_react16.default.memo(function SearchResults2({
  query,
  results,
  closeMenu,
  getItemProps,
  highlightedIndex,
  clearLastViewed
}) {
  const handleClearLastViewed = () => {
    clearLastViewed();
    closeMenu();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(ResultsList, { children: [
    results.length > 0 && !query ? /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(RecentlyOpenedTitle, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { children: "Recently opened" }),
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(IconButton, { onPress: handleClearLastViewed })
    ] }) : null,
    results.length === 0 && query ? /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(import_react_native4.View, { children: /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(NoResults, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { style: { marginBottom: 8 }, children: "No components found" }),
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Text, { children: "Find components by name or path." })
    ] }) }) : null,
    results.map((result, index) => {
      if (isExpandType(result)) {
        return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(MoreWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          Button,
          {
            ...result,
            ...getItemProps({ key: `${index}`, index, item: result }),
            size: "small",
            text: `Show ${result.moreCount} more results`
          }
        ) }, "search-result-expand");
      }
      const { item } = result;
      const key = `${item.refId}::${item.id}`;
      return /* @__PURE__ */ (0, import_react17.createElement)(
        Result,
        {
          ...result,
          ...getItemProps({ key, index, item: result }),
          isHighlighted: highlightedIndex === index,
          key: item.id
        }
      );
    })
  ] });
});

// src/hooks/useLastViewed.ts
var import_debounce = __toESM(require("lodash/debounce.js"));
var import_react18 = require("react");
var import_store2 = __toESM(require("store2"));
var save = (0, import_debounce.default)((value) => import_store2.default.set("lastViewedStoryIds", value), 1e3);
var useLastViewed = (selection) => {
  const initialLastViewedStoryIds = (0, import_react18.useMemo)(() => {
    const items = import_store2.default.get("lastViewedStoryIds");
    if (!items || !Array.isArray(items))
      return [];
    if (!items.some((item) => typeof item === "object" && item.storyId && item.refId))
      return [];
    return items;
  }, []);
  const lastViewedRef = (0, import_react18.useRef)(initialLastViewedStoryIds);
  const updateLastViewed = (0, import_react18.useCallback)(
    (story) => {
      const items = lastViewedRef.current;
      const index = items.findIndex(
        ({ storyId, refId }) => storyId === story.storyId && refId === story.refId
      );
      if (index === 0)
        return;
      if (index === -1) {
        lastViewedRef.current = [story, ...items];
      } else {
        lastViewedRef.current = [story, ...items.slice(0, index), ...items.slice(index + 1)];
      }
      save(lastViewedRef.current);
    },
    [lastViewedRef]
  );
  (0, import_react18.useEffect)(() => {
    if (selection)
      updateLastViewed(selection);
  }, [selection]);
  return {
    getLastViewed: (0, import_react18.useCallback)(() => lastViewedRef.current, [lastViewedRef]),
    clearLastViewed: (0, import_react18.useCallback)(() => {
      lastViewedRef.current = lastViewedRef.current.slice(0, 1);
      save(lastViewedRef.current);
    }, [lastViewedRef])
  };
};

// src/Sidebar.tsx
var import_react_native5 = require("react-native");
var import_jsx_runtime20 = require("react/jsx-runtime");
var Container2 = import_react_native_theming12.styled.View(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.background.content
}));
var Top = import_react_native_theming12.styled.View({
  paddingLeft: 4,
  paddingRight: 4,
  paddingTop: 16,
  flex: 1,
  flexDirection: "row"
});
var Swap = import_react19.default.memo(function Swap2({
  children,
  condition
}) {
  const [a, b] = import_react19.default.Children.toArray(children);
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)(import_jsx_runtime20.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(import_react_native5.View, { style: { display: condition ? "flex" : "none" }, children: a }),
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(import_react_native5.View, { style: { display: condition ? "none" : "flex" }, children: b })
  ] });
});
var useCombination = (index, indexError, previewInitialized, status, refs) => {
  const hash = (0, import_react19.useMemo)(
    () => ({
      [DEFAULT_REF_ID]: {
        index,
        indexError,
        previewInitialized,
        status,
        title: null,
        id: DEFAULT_REF_ID,
        url: "iframe.html"
      },
      ...refs
    }),
    [refs, index, indexError, previewInitialized, status]
  );
  return (0, import_react19.useMemo)(() => ({ hash, entries: Object.entries(hash) }), [hash]);
};
var Sidebar = import_react19.default.memo(function Sidebar2({
  storyId = null,
  refId = DEFAULT_REF_ID,
  index,
  indexError,
  status,
  previewInitialized,
  refs = {},
  setSelection
}) {
  const selected = (0, import_react19.useMemo)(() => storyId && { storyId, refId }, [storyId, refId]);
  const dataset = useCombination(index, indexError, previewInitialized, status, refs);
  const lastViewedProps = useLastViewed(selected);
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(Container2, { style: { paddingHorizontal: 10 }, children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(Top, { children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(Search, { dataset, setSelection, ...lastViewedProps, children: ({ query, results, isBrowsing, closeMenu, getItemProps, highlightedIndex }) => /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)(Swap, { condition: isBrowsing, children: [
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      Explorer,
      {
        dataset,
        selected,
        isLoading: false,
        isBrowsing,
        setSelection
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      SearchResults,
      {
        query,
        results,
        closeMenu,
        getItemProps,
        highlightedIndex,
        isLoading: false,
        clearLastViewed: lastViewedProps.clearLastViewed
      }
    )
  ] }) }) }) });
});

// src/Layout.tsx
var import_core_events = require("@storybook/core/core-events");
var import_manager_api2 = require("@storybook/core/manager-api");
var import_react_native_theming18 = require("@storybook/react-native-theming");
var import_react28 = require("react");
var import_react_native9 = require("react-native");
var import_react_native_safe_area_context3 = require("react-native-safe-area-context");

// src/MobileAddonsPanel.tsx
var import_bottom_sheet2 = require("@gorhom/bottom-sheet");
var import_manager_api = require("@storybook/core/manager-api");
var import_react_native_theming13 = require("@storybook/react-native-theming");
var import_types3 = require("@storybook/core/types");
var import_react21 = require("react");
var import_react_native6 = require("react-native");
var import_react_native_gesture_handler = require("react-native-gesture-handler");
var import_react_native_reanimated = __toESM(require("react-native-reanimated"));
var import_react_native_safe_area_context = require("react-native-safe-area-context");
var import_react_native_theming14 = require("@storybook/react-native-theming");

// src/util/useStyle.ts
var import_react20 = require("react");
var useStyle = (styleFactory, deps) => (
  // eslint-disable-next-line react-hooks/exhaustive-deps
  (0, import_react20.useMemo)(styleFactory, deps)
);

// src/MobileAddonsPanel.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
var bottomSheetStyle = {
  paddingTop: 8
};
var contentStyle = {
  flex: 1
};
var MobileAddonsPanel = (0, import_react21.forwardRef)(
  ({ storyId }, ref) => {
    const theme = (0, import_react_native_theming14.useTheme)();
    const reducedMotion = (0, import_react_native_reanimated.useReducedMotion)();
    const addonsPanelBottomSheetRef = (0, import_react21.useRef)(null);
    const insets = (0, import_react_native_safe_area_context.useSafeAreaInsets)();
    const animatedPosition = (0, import_react_native_reanimated.useSharedValue)(0);
    (0, import_react_native_reanimated.useAnimatedKeyboard)();
    (0, import_react21.useImperativeHandle)(ref, () => ({
      setAddonsPanelOpen: (open) => {
        if (open) {
          addonsPanelBottomSheetRef.current?.present();
        } else {
          addonsPanelBottomSheetRef.current?.dismiss();
        }
      }
    }));
    const { height } = (0, import_react_native6.useWindowDimensions)();
    const adjustedBottomSheetSize = (0, import_react_native_reanimated.useAnimatedStyle)(() => {
      const extraPadding = import_react_native6.Platform.OS === "android" ? 32 : 16;
      return {
        maxHeight: height - animatedPosition.value - insets.bottom - extraPadding
      };
    }, [animatedPosition, height, insets.bottom]);
    const backgroundStyle = useStyle(() => {
      return {
        borderRadius: 0,
        borderTopColor: theme.appBorderColor,
        borderTopWidth: 1,
        backgroundColor: theme.background.content
      };
    });
    const handleIndicatorStyle = useStyle(() => {
      return {
        backgroundColor: theme.textMutedColor
      };
    });
    return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
      import_bottom_sheet2.BottomSheetModal,
      {
        ref: addonsPanelBottomSheetRef,
        index: 1,
        animateOnMount: !reducedMotion,
        snapPoints: ["25%", "50%", "75%"],
        style: bottomSheetStyle,
        animatedPosition,
        backgroundStyle,
        handleIndicatorStyle,
        keyboardBehavior: "extend",
        enableDismissOnClose: true,
        enableHandlePanningGesture: true,
        stackBehavior: "replace",
        enableDynamicSizing: false,
        children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(import_react_native_reanimated.default.View, { style: [contentStyle, adjustedBottomSheetSize], children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
          AddonsTabs,
          {
            onClose: () => {
              addonsPanelBottomSheetRef.current?.dismiss();
            },
            storyId
          }
        ) })
      }
    );
  }
);
var addonsTabsContainerStyle = {
  flex: 1
};
var addonsTabsStyle = {
  flexDirection: "row",
  borderBottomWidth: 1,
  borderBottomColor: "lightgrey"
};
var addonsTabsContentContainerStyle = {
  justifyContent: "center"
};
var closeIconStyle = {
  marginRight: 4,
  marginBottom: 4,
  alignItems: "center",
  justifyContent: "center"
};
var addonsScrollStyle = {
  flex: 1
};
var centeredStyle = {
  alignItems: "center",
  justifyContent: "center"
};
var hitSlop = { top: 10, right: 10, bottom: 10, left: 10 };
var AddonsTabs = ({ onClose, storyId }) => {
  const panels = import_manager_api.addons.getElements(import_types3.Addon_TypesEnum.PANEL);
  const [addonSelected, setAddonSelected] = (0, import_react21.useState)(Object.keys(panels)[0]);
  const insets = (0, import_react_native_safe_area_context.useSafeAreaInsets)();
  const scrollContentContainerStyle = useStyle(() => {
    return {
      paddingBottom: insets.bottom + 16
    };
  });
  const panel = (0, import_react21.useMemo)(() => {
    if (!storyId) {
      return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(import_react_native6.View, { style: centeredStyle, children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(import_react_native6.Text, { children: "No Story Selected" }) });
    }
    if (Object.keys(panels).length === 0) {
      return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(import_react_native6.View, { style: centeredStyle, children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(import_react_native6.Text, { children: "No addons loaded." }) });
    }
    return panels[addonSelected].render({ active: true });
  }, [addonSelected, panels, storyId]);
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(import_react_native6.View, { style: addonsTabsContainerStyle, children: [
    /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(import_react_native6.View, { style: addonsTabsStyle, children: [
      /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
        import_react_native_gesture_handler.ScrollView,
        {
          horizontal: true,
          showsHorizontalScrollIndicator: false,
          contentContainerStyle: addonsTabsContentContainerStyle,
          children: Object.values(panels).map(({ id, title }) => {
            const resolvedTitle = typeof title === "function" ? title({}) : title;
            return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
              Tab,
              {
                active: id === addonSelected,
                onPress: () => setAddonSelected(id),
                text: resolvedTitle
              },
              id
            );
          })
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
        IconButton,
        {
          style: closeIconStyle,
          hitSlop,
          Icon: CloseIcon,
          onPress: () => onClose?.()
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
      import_react_native_gesture_handler.ScrollView,
      {
        style: addonsScrollStyle,
        contentContainerStyle: scrollContentContainerStyle,
        children: panel
      }
    )
  ] });
};
var Tab = ({ active, onPress, text }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(TabButton, { active, onPress, children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(TabText, { active, children: text }) });
};
var TabButton = import_react_native_theming13.styled.TouchableOpacity(({ theme, active }) => ({
  borderBottomWidth: active ? 2 : 0,
  borderBottomColor: active ? theme.barSelectedColor : void 0,
  overflow: "hidden",
  paddingHorizontal: 15,
  justifyContent: "center",
  alignItems: "center"
}));
var TabText = import_react_native_theming13.styled.Text(({ theme, active }) => ({
  color: active ? theme.barSelectedColor : theme.color.mediumdark,
  textAlign: "center",
  fontWeight: "bold",
  fontSize: 12,
  lineHeight: 12
}));

// src/MobileMenuDrawer.tsx
var import_bottom_sheet3 = __toESM(require("@gorhom/bottom-sheet"));
var import_react_native_theming15 = require("@storybook/react-native-theming");
var import_react22 = require("react");
var import_react_native7 = require("react-native");
var import_react_native_reanimated2 = require("react-native-reanimated");
var import_react_native_safe_area_context2 = require("react-native-safe-area-context");
var import_jsx_runtime22 = require("react/jsx-runtime");
var BottomSheetBackdropComponent = (backdropComponentProps) => /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
  import_bottom_sheet3.BottomSheetBackdrop,
  {
    ...backdropComponentProps,
    appearsOnIndex: 0,
    disappearsOnIndex: -1,
    pressBehavior: "close",
    style: [backdropComponentProps.style, { backgroundColor: "rgba(0,0,0,0.5)" }]
  }
);
var snapPoints = ["50%", "75%"];
var MobileMenuDrawer = (0, import_react22.memo)(
  (0, import_react22.forwardRef)(({ children }, ref) => {
    const reducedMotion = (0, import_react_native_reanimated2.useReducedMotion)();
    const insets = (0, import_react_native_safe_area_context2.useSafeAreaInsets)();
    const theme = (0, import_react_native_theming15.useTheme)();
    const menuBottomSheetRef = (0, import_react22.useRef)(null);
    const { scrollToSelectedNode, scrollRef } = useSelectedNode();
    (0, import_react22.useImperativeHandle)(ref, () => ({
      setMobileMenuOpen: (open) => {
        if (open) {
          menuBottomSheetRef.current?.snapToIndex(1);
          scrollToSelectedNode();
        } else {
          import_react_native7.Keyboard.dismiss();
          menuBottomSheetRef.current?.close();
        }
      }
    }));
    const bgColorStyle = (0, import_react22.useMemo)(() => {
      return { backgroundColor: theme.background.content };
    }, [theme.background.content]);
    const handleIndicatorStyle = (0, import_react22.useMemo)(() => {
      return { backgroundColor: theme.textMutedColor };
    }, [theme.textMutedColor]);
    const contentContainerStyle2 = (0, import_react22.useMemo)(() => {
      return { paddingBottom: insets.bottom };
    }, [insets.bottom]);
    return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      import_bottom_sheet3.default,
      {
        ref: menuBottomSheetRef,
        index: -1,
        animateOnMount: !reducedMotion,
        snapPoints,
        enableHandlePanningGesture: true,
        enableContentPanningGesture: true,
        enableDynamicSizing: false,
        keyboardBehavior: "extend",
        keyboardBlurBehavior: "restore",
        enablePanDownToClose: true,
        backdropComponent: BottomSheetBackdropComponent,
        backgroundStyle: bgColorStyle,
        handleIndicatorStyle,
        children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          import_bottom_sheet3.BottomSheetScrollView,
          {
            ref: scrollRef,
            keyboardShouldPersistTaps: "handled",
            contentContainerStyle: contentContainerStyle2,
            children
          }
        )
      }
    );
  })
);

// src/StorybookLogo.tsx
var import_react23 = require("react");
var import_react_native8 = require("react-native");

// src/icon/DarkLogo.tsx
var import_react_native_svg10 = __toESM(require("react-native-svg"));
var import_jsx_runtime23 = require("react/jsx-runtime");
function DarkLogo({ width = 300, height = 60, ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(import_react_native_svg10.default, { width, height, viewBox: "0 0 300 60", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(import_react_native_svg10.Defs, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        import_react_native_svg10.Path,
        {
          id: "a",
          d: "M1.848 54.92L.002 5.723A2.997 2.997 0 012.81 2.621L44.654.006a2.997 2.997 0 013.183 2.99v53.607a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        import_react_native_svg10.Path,
        {
          id: "c",
          d: "M1.848 54.92L.002 5.723A2.997 2.997 0 012.81 2.621L44.654.006a2.997 2.997 0 013.183 2.99v53.607a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882z"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(import_react_native_svg10.G, { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        import_react_native_svg10.Path,
        {
          fill: "#FFF",
          fillRule: "nonzero",
          d: "M80.387 47.178c-2.543 0-4.99-.342-7.343-1.025-2.352-.684-4.307-1.63-5.864-2.837l2.384-5.293c3.242 2.257 6.882 3.386 10.919 3.386 2.097 0 3.71-.342 4.84-1.026 1.128-.683 1.692-1.629 1.692-2.836 0-1.081-.517-1.924-1.55-2.528-1.033-.603-2.869-1.192-5.507-1.764-2.956-.604-5.316-1.335-7.08-2.193-1.765-.858-3.052-1.915-3.862-3.17-.811-1.256-1.216-2.806-1.216-4.65 0-2.034.564-3.846 1.692-5.435 1.129-1.59 2.71-2.837 4.744-3.743 2.035-.906 4.387-1.359 7.057-1.359 2.384 0 4.68.35 6.89 1.05 2.21.699 3.965 1.636 5.269 2.812l-2.384 5.293c-3.084-2.257-6.326-3.385-9.727-3.385-1.94 0-3.465.373-4.577 1.12-1.113.747-1.67 1.772-1.67 3.075 0 .763.215 1.391.644 1.884.43.492 1.145.93 2.146 1.31 1.001.382 2.424.78 4.267 1.193 4.323.954 7.43 2.177 9.322 3.671 1.891 1.494 2.837 3.56 2.837 6.199 0 3.178-1.224 5.682-3.672 7.51-2.447 1.827-5.864 2.74-10.25 2.74zm31.183-5.34c.731 0 1.494-.048 2.289-.143l-.382 5.244c-.922.128-1.844.191-2.765.191-3.56 0-6.159-.779-7.796-2.336-1.637-1.558-2.456-3.926-2.456-7.104v-8.964h-4.434v-5.388h4.434v-6.866h7.2v6.866h5.865v5.388h-5.865v8.916c0 2.797 1.303 4.196 3.91 4.196zm16.736 5.292c-2.48 0-4.657-.5-6.533-1.502-1.875-1.001-3.321-2.416-4.338-4.243-1.018-1.828-1.526-3.982-1.526-6.46 0-2.48.508-4.634 1.526-6.462 1.017-1.827 2.463-3.234 4.338-4.22 1.876-.985 4.053-1.477 6.533-1.477 2.479 0 4.656.492 6.532 1.478 1.875.985 3.321 2.392 4.339 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.525 6.46c-1.018 1.828-2.464 3.243-4.34 4.244-1.875 1.002-4.052 1.502-6.531 1.502zm0-5.483c3.496 0 5.244-2.24 5.244-6.723 0-2.257-.453-3.941-1.358-5.054-.906-1.113-2.202-1.669-3.886-1.669-3.497 0-5.245 2.241-5.245 6.723 0 4.482 1.748 6.723 5.245 6.723zm32.327-12.969l-4.053.43c-2.003.19-3.417.754-4.244 1.692-.826.938-1.24 2.185-1.24 3.743v12.206h-7.199V23.338h6.914v3.957c1.176-2.702 3.607-4.18 7.295-4.434l2.098-.143.429 5.96zm20.92-5.292h7.056L174.496 55.33H167.2l4.481-9.87-9.63-22.075h7.485l5.912 14.876 6.103-14.876zm23.744-.62c2.034 0 3.83.492 5.388 1.478 1.557.985 2.773 2.392 3.647 4.22.874 1.827 1.311 3.949 1.311 6.365 0 2.416-.437 4.553-1.31 6.413-.875 1.86-2.099 3.306-3.672 4.339-1.574 1.033-3.362 1.55-5.364 1.55-1.621 0-3.083-.343-4.387-1.026-1.303-.683-2.304-1.629-3.004-2.837v3.48h-7.104V13.135h7.2v13.35c.7-1.175 1.692-2.09 2.98-2.74 1.287-.652 2.726-.978 4.315-.978zm-2.098 18.881c1.685 0 2.988-.596 3.91-1.788.922-1.192 1.382-2.869 1.382-5.03 0-2.13-.46-3.759-1.382-4.887-.922-1.129-2.225-1.693-3.91-1.693s-2.988.58-3.91 1.74c-.922 1.16-1.383 2.805-1.383 4.935 0 2.162.461 3.822 1.383 4.983.922 1.16 2.225 1.74 3.91 1.74zm28.083 5.483c-2.479 0-4.656-.5-6.532-1.502-1.875-1.001-3.321-2.416-4.339-4.243-1.017-1.828-1.525-3.982-1.525-6.46 0-2.48.508-4.634 1.525-6.462 1.018-1.827 2.464-3.234 4.34-4.22 1.875-.985 4.052-1.477 6.531-1.477 2.48 0 4.657.492 6.533 1.478 1.875.985 3.321 2.392 4.339 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.525 6.46c-1.018 1.828-2.464 3.243-4.34 4.244-1.875 1.002-4.052 1.502-6.532 1.502zm0-5.483c3.497 0 5.245-2.24 5.245-6.723 0-2.257-.453-3.941-1.359-5.054-.906-1.113-2.2-1.669-3.886-1.669-3.496 0-5.244 2.241-5.244 6.723 0 4.482 1.748 6.723 5.244 6.723zm26.844 5.483c-2.48 0-4.656-.5-6.532-1.502-1.875-1.001-3.322-2.416-4.339-4.243-1.017-1.828-1.525-3.982-1.525-6.46 0-2.48.508-4.634 1.525-6.462 1.017-1.827 2.464-3.234 4.34-4.22 1.875-.985 4.052-1.477 6.531-1.477 2.48 0 4.657.492 6.532 1.478 1.876.985 3.322 2.392 4.34 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.526 6.46c-1.017 1.828-2.463 3.243-4.339 4.244-1.875 1.002-4.052 1.502-6.532 1.502zm0-5.483c3.497 0 5.245-2.24 5.245-6.723 0-2.257-.453-3.941-1.359-5.054-.906-1.113-2.201-1.669-3.886-1.669-3.496 0-5.244 2.241-5.244 6.723 0 4.482 1.748 6.723 5.244 6.723zM299 46.749h-8.82l-8.965-10.442v10.442h-7.2V13.134h7.2v20.217l8.63-9.965h8.583l-9.822 11.157L299 46.749z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        import_react_native_svg10.Path,
        {
          d: "M48.831 2.81c.004.062.006.124.006.187v53.606a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882L1.002 5.724A2.997 2.997 0 013.81 2.621L36.609.57l-.285 6.756a.447.447 0 00.05.223l.04.066c.15.196.43.235.627.085l2.623-1.99 2.217 1.746a.447.447 0 00.723-.367L42.356.211l3.298-.205A2.997 2.997 0 0148.83 2.81z",
          fill: "#FF4785",
          fillRule: "nonzero"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(import_react_native_svg10.G, { transform: "translate(1)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_react_native_svg10.Mask, { id: "b", fill: "#fff", children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_react_native_svg10.Use, { xlinkHref: "#a" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
          import_react_native_svg10.Path,
          {
            fill: "#FFF",
            fillRule: "nonzero",
            d: "M35.324 7.326L35.61.569l5.746-.36.248 6.88a.447.447 0 01-.723.367L38.664 5.71 36.041 7.7a.447.447 0 01-.717-.374z",
            mask: "url(#b)"
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(import_react_native_svg10.G, { transform: "translate(1)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_react_native_svg10.Mask, { id: "d", fill: "#fff", children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_react_native_svg10.Use, { xlinkHref: "#c" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
          import_react_native_svg10.Path,
          {
            fill: "#FFF",
            fillRule: "nonzero",
            d: "M27.975 22.464c0 1.166 7.853.607 8.907-.212 0-7.939-4.26-12.11-12.06-12.11-7.801 0-12.172 4.236-12.172 10.591 0 11.069 14.938 11.28 14.938 17.318 0 1.695-.83 2.7-2.656 2.7-2.379 0-3.32-1.214-3.209-5.345 0-.896-9.073-1.175-9.35 0-.704 10.01 5.533 12.898 12.67 12.898 6.915 0 12.337-3.686 12.337-10.36 0-11.862-15.159-11.544-15.159-17.423 0-2.383 1.77-2.7 2.822-2.7 1.106 0 3.098.194 2.932 4.643z",
            mask: "url(#d)"
          }
        )
      ] })
    ] })
  ] });
}

// src/icon/Logo.tsx
var import_react_native_svg11 = __toESM(require("react-native-svg"));
var import_jsx_runtime24 = require("react/jsx-runtime");
function Logo({ width = 300, height = 60, ...props }) {
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_react_native_svg11.default, { width, height, viewBox: "0 0 300 60", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_react_native_svg11.Defs, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        import_react_native_svg11.Path,
        {
          id: "a",
          d: "M1.848 54.92L.002 5.723A2.997 2.997 0 012.81 2.621L44.654.006a2.997 2.997 0 013.183 2.99v53.607a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        import_react_native_svg11.Path,
        {
          id: "c",
          d: "M1.848 54.92L.002 5.723A2.997 2.997 0 012.81 2.621L44.654.006a2.997 2.997 0 013.183 2.99v53.607a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882z"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_react_native_svg11.G, { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        import_react_native_svg11.Path,
        {
          fill: "#333",
          fillRule: "nonzero",
          d: "M80.387 47.178c-2.543 0-4.99-.342-7.343-1.025-2.352-.684-4.307-1.63-5.864-2.837l2.384-5.293c3.242 2.257 6.882 3.386 10.919 3.386 2.097 0 3.71-.342 4.84-1.026 1.128-.683 1.692-1.629 1.692-2.836 0-1.081-.517-1.924-1.55-2.528-1.033-.603-2.869-1.192-5.507-1.764-2.956-.604-5.316-1.335-7.08-2.193-1.765-.858-3.052-1.915-3.862-3.17-.811-1.256-1.216-2.806-1.216-4.65 0-2.034.564-3.846 1.692-5.435 1.129-1.59 2.71-2.837 4.744-3.743 2.035-.906 4.387-1.359 7.057-1.359 2.384 0 4.68.35 6.89 1.05 2.21.699 3.965 1.636 5.269 2.812l-2.384 5.293c-3.084-2.257-6.326-3.385-9.727-3.385-1.94 0-3.465.373-4.577 1.12-1.113.747-1.67 1.772-1.67 3.075 0 .763.215 1.391.644 1.884.43.492 1.145.93 2.146 1.31 1.001.382 2.424.78 4.267 1.193 4.323.954 7.43 2.177 9.322 3.671 1.891 1.494 2.837 3.56 2.837 6.199 0 3.178-1.224 5.682-3.672 7.51-2.447 1.827-5.864 2.74-10.25 2.74zm31.183-5.34c.731 0 1.494-.048 2.289-.143l-.382 5.244c-.922.128-1.844.191-2.765.191-3.56 0-6.159-.779-7.796-2.336-1.637-1.558-2.456-3.926-2.456-7.104v-8.964h-4.434v-5.388h4.434v-6.866h7.2v6.866h5.865v5.388h-5.865v8.916c0 2.797 1.303 4.196 3.91 4.196zm16.736 5.292c-2.48 0-4.657-.5-6.533-1.502-1.875-1.001-3.321-2.416-4.338-4.243-1.018-1.828-1.526-3.982-1.526-6.46 0-2.48.508-4.634 1.526-6.462 1.017-1.827 2.463-3.234 4.338-4.22 1.876-.985 4.053-1.477 6.533-1.477 2.479 0 4.656.492 6.532 1.478 1.875.985 3.321 2.392 4.339 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.525 6.46c-1.018 1.828-2.464 3.243-4.34 4.244-1.875 1.002-4.052 1.502-6.531 1.502zm0-5.483c3.496 0 5.244-2.24 5.244-6.723 0-2.257-.453-3.941-1.358-5.054-.906-1.113-2.202-1.669-3.886-1.669-3.497 0-5.245 2.241-5.245 6.723 0 4.482 1.748 6.723 5.245 6.723zm32.327-12.969l-4.053.43c-2.003.19-3.417.754-4.244 1.692-.826.938-1.24 2.185-1.24 3.743v12.206h-7.199V23.338h6.914v3.957c1.176-2.702 3.607-4.18 7.295-4.434l2.098-.143.429 5.96zm20.92-5.292h7.056L174.496 55.33H167.2l4.481-9.87-9.63-22.075h7.485l5.912 14.876 6.103-14.876zm23.744-.62c2.034 0 3.83.492 5.388 1.478 1.557.985 2.773 2.392 3.647 4.22.874 1.827 1.311 3.949 1.311 6.365 0 2.416-.437 4.553-1.31 6.413-.875 1.86-2.099 3.306-3.672 4.339-1.574 1.033-3.362 1.55-5.364 1.55-1.621 0-3.083-.343-4.387-1.026-1.303-.683-2.304-1.629-3.004-2.837v3.48h-7.104V13.135h7.2v13.35c.7-1.175 1.692-2.09 2.98-2.74 1.287-.652 2.726-.978 4.315-.978zm-2.098 18.881c1.685 0 2.988-.596 3.91-1.788.922-1.192 1.382-2.869 1.382-5.03 0-2.13-.46-3.759-1.382-4.887-.922-1.129-2.225-1.693-3.91-1.693s-2.988.58-3.91 1.74c-.922 1.16-1.383 2.805-1.383 4.935 0 2.162.461 3.822 1.383 4.983.922 1.16 2.225 1.74 3.91 1.74zm28.083 5.483c-2.479 0-4.656-.5-6.532-1.502-1.875-1.001-3.321-2.416-4.339-4.243-1.017-1.828-1.525-3.982-1.525-6.46 0-2.48.508-4.634 1.525-6.462 1.018-1.827 2.464-3.234 4.34-4.22 1.875-.985 4.052-1.477 6.531-1.477 2.48 0 4.657.492 6.533 1.478 1.875.985 3.321 2.392 4.339 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.525 6.46c-1.018 1.828-2.464 3.243-4.34 4.244-1.875 1.002-4.052 1.502-6.532 1.502zm0-5.483c3.497 0 5.245-2.24 5.245-6.723 0-2.257-.453-3.941-1.359-5.054-.906-1.113-2.2-1.669-3.886-1.669-3.496 0-5.244 2.241-5.244 6.723 0 4.482 1.748 6.723 5.244 6.723zm26.844 5.483c-2.48 0-4.656-.5-6.532-1.502-1.875-1.001-3.322-2.416-4.339-4.243-1.017-1.828-1.525-3.982-1.525-6.46 0-2.48.508-4.634 1.525-6.462 1.017-1.827 2.464-3.234 4.34-4.22 1.875-.985 4.052-1.477 6.531-1.477 2.48 0 4.657.492 6.532 1.478 1.876.985 3.322 2.392 4.34 4.22 1.017 1.827 1.525 3.98 1.525 6.46s-.508 4.633-1.526 6.46c-1.017 1.828-2.463 3.243-4.339 4.244-1.875 1.002-4.052 1.502-6.532 1.502zm0-5.483c3.497 0 5.245-2.24 5.245-6.723 0-2.257-.453-3.941-1.359-5.054-.906-1.113-2.201-1.669-3.886-1.669-3.496 0-5.244 2.241-5.244 6.723 0 4.482 1.748 6.723 5.244 6.723zM299 46.749h-8.82l-8.965-10.442v10.442h-7.2V13.134h7.2v20.217l8.63-9.965h8.583l-9.822 11.157L299 46.749z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        import_react_native_svg11.Path,
        {
          d: "M48.831 2.81c.004.062.006.124.006.187v53.606a2.997 2.997 0 01-3.13 2.994l-40-1.796a2.997 2.997 0 01-2.86-2.882L1.002 5.724A2.997 2.997 0 013.81 2.621L36.609.57l-.285 6.756a.447.447 0 00.05.223l.04.066c.15.196.43.235.627.085l2.623-1.99 2.217 1.746a.447.447 0 00.723-.367L42.356.211l3.298-.205A2.997 2.997 0 0148.83 2.81z",
          fill: "#FF4785",
          fillRule: "nonzero"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_react_native_svg11.G, { transform: "translate(1)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_react_native_svg11.Mask, { id: "b", fill: "#fff", children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_react_native_svg11.Use, { xlinkHref: "#a" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
          import_react_native_svg11.Path,
          {
            fill: "#FFF",
            fillRule: "nonzero",
            d: "M35.324 7.326L35.61.569l5.746-.36.248 6.88a.447.447 0 01-.723.367L38.664 5.71 36.041 7.7a.447.447 0 01-.717-.374z",
            mask: "url(#b)"
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)(import_react_native_svg11.G, { transform: "translate(1)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_react_native_svg11.Mask, { id: "d", fill: "#fff", children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_react_native_svg11.Use, { xlinkHref: "#c" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
          import_react_native_svg11.Path,
          {
            fill: "#FFF",
            fillRule: "nonzero",
            d: "M27.975 22.464c0 1.166 7.853.607 8.907-.212 0-7.939-4.26-12.11-12.06-12.11-7.801 0-12.172 4.236-12.172 10.591 0 11.069 14.938 11.28 14.938 17.318 0 1.695-.83 2.7-2.656 2.7-2.379 0-3.32-1.214-3.209-5.345 0-.896-9.073-1.175-9.35 0-.704 10.01 5.533 12.898 12.67 12.898 6.915 0 12.337-3.686 12.337-10.36 0-11.862-15.159-11.544-15.159-17.423 0-2.383 1.77-2.7 2.822-2.7 1.106 0 3.098.194 2.932 4.643z",
            mask: "url(#d)"
          }
        )
      ] })
    ] })
  ] });
}

// src/StorybookLogo.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
var WIDTH = 125;
var HEIGHT = 25;
var NoBrandLogo = ({ theme }) => theme.base === "light" ? /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(Logo, { height: HEIGHT, width: WIDTH }) : /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(DarkLogo, { height: HEIGHT, width: WIDTH });
function isElement(value) {
  return (0, import_react23.isValidElement)(value);
}
var BrandLogo = ({ theme }) => {
  const imageHasNoWidthOrHeight = typeof theme.brand.image === "object" && typeof theme.brand.image === "object" && "uri" in theme.brand.image && (!("height" in theme.brand.image) || !("width" in theme.brand.image));
  (0, import_react23.useEffect)(() => {
    if (imageHasNoWidthOrHeight) {
      console.warn(
        "STORYBOOK: When using a remote image as the brand logo, you must also set the width and height.\nFor example:  brand: { image: { uri: 'https://sb.com/img.png', height: 25, width: 25}}"
      );
    }
  }, [imageHasNoWidthOrHeight]);
  if (!theme.brand.image) {
    return null;
  }
  if (isElement(theme.brand.image)) {
    return theme.brand.image;
  }
  const image = /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
    import_react_native8.Image,
    {
      source: theme.brand.image,
      resizeMode: theme.brand.resizeMode ?? "contain",
      style: imageHasNoWidthOrHeight ? { width: WIDTH, height: HEIGHT } : void 0
    }
  );
  if (theme.brand.url) {
    return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
      import_react_native8.TouchableOpacity,
      {
        onPress: () => {
          if (theme.brand.url)
            import_react_native8.Linking.openURL(theme.brand.url);
        },
        children: image
      }
    );
  } else {
    return image;
  }
};
var BrandTitle = ({ theme }) => {
  const brandTitleStyle = (0, import_react23.useMemo)(() => {
    return {
      width: WIDTH,
      height: HEIGHT,
      color: theme.color.defaultText,
      fontSize: theme.typography.size.m1
    };
  }, [theme]);
  const title = /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(import_react_native8.Text, { style: brandTitleStyle, numberOfLines: 1, ellipsizeMode: "tail", children: theme.brand.title });
  if (theme.brand.url) {
    return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
      import_react_native8.TouchableOpacity,
      {
        onPress: () => {
          if (theme.brand.url)
            import_react_native8.Linking.openURL(theme.brand.url);
        },
        children: title
      }
    );
  } else {
    return title;
  }
};
var StorybookLogo = ({ theme }) => {
  const image = (0, import_react23.useMemo)(() => theme.brand?.image, [theme.brand?.image]);
  const title = (0, import_react23.useMemo)(() => theme.brand?.title, [theme.brand?.title]);
  if (image) {
    return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(BrandLogo, { theme });
  } else if (title) {
    return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(BrandTitle, { theme });
  } else {
    return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(NoBrandLogo, { theme });
  }
};

// src/hooks/useStoreState.ts
var import_react25 = require("react");

// src/StorageProvider.tsx
var import_react24 = require("react");
var import_jsx_runtime26 = require("react/jsx-runtime");
var StorageContext = (0, import_react24.createContext)({
  getItem: async () => null,
  setItem: async () => {
  }
});
var StorageProvider = ({
  storage,
  children
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(StorageContext.Provider, { value: storage, children });
};
var useStorage = () => (0, import_react24.useContext)(StorageContext);

// src/hooks/useStoreState.ts
var useStoreBooleanState = (key, defaultValue) => {
  const storage = useStorage();
  const [val, setVal] = (0, import_react25.useState)(defaultValue);
  (0, import_react25.useEffect)(() => {
    storage.getItem(key).then((newVal) => {
      if (newVal === null || newVal === void 0) {
        setVal(defaultValue);
      } else {
        setVal(newVal === "true");
      }
    });
  }, [key, storage, defaultValue]);
  (0, import_react25.useEffect)(() => {
    storage.setItem(key, val.toString());
  }, [key, storage, val]);
  return [val, setVal];
};

// src/icon/BottomBarToggleIcon.tsx
var import_react_native_svg12 = require("react-native-svg");
var import_jsx_runtime27 = require("react/jsx-runtime");
var BottomBarToggleIcon = ({
  color = "currentColor",
  width = 14,
  height = 14,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(import_react_native_svg12.Svg, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      import_react_native_svg12.Path,
      {
        d: "M3.5 10.004a.5.5 0 000 1h1a.5.5 0 000-1h-1zM6 10.504a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM9.5 10.004a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
        fill: color
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      import_react_native_svg12.Path,
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 12.504v-11a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5zm1-.5v-3h10v3H2zm4.5-4H2v-6h10v6H7.5V5.21l.646.646a.5.5 0 10.708-.707l-1.5-1.5a.5.5 0 00-.708 0l-1.5 1.5a.5.5 0 10.708.707l.646-.646v2.793z",
        fill: color
      }
    )
  ] });
};

// src/icon/CloseFullscreenIcon.tsx
var import_react26 = require("react");
var import_react_native_svg13 = __toESM(require("react-native-svg"));
var import_react_native_theming16 = require("@storybook/react-native-theming");
var import_jsx_runtime28 = require("react/jsx-runtime");
function CloseFullscreenIcon({ color, width = 14, height = 14, ...props }) {
  const theme = (0, import_react_native_theming16.useTheme)();
  const fillColor = (0, import_react26.useMemo)(() => {
    return color ?? theme.color.defaultText;
  }, [color, theme.color.defaultText]);
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_react_native_svg13.default, { fill: fillColor, height, viewBox: "0 0 16 16", width, ...props, children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_react_native_svg13.Path, { d: "M5.5 0a.5.5 0 01.5.5v4A1.5 1.5 0 014.5 6h-4a.5.5 0 010-1h4a.5.5 0 00.5-.5v-4a.5.5 0 01.5-.5zm5 0a.5.5 0 01.5.5v4a.5.5 0 00.5.5h4a.5.5 0 010 1h-4A1.5 1.5 0 0110 4.5v-4a.5.5 0 01.5-.5zM0 10.5a.5.5 0 01.5-.5h4A1.5 1.5 0 016 11.5v4a.5.5 0 01-1 0v-4a.5.5 0 00-.5-.5h-4a.5.5 0 01-.5-.5zm10 1a1.5 1.5 0 011.5-1.5h4a.5.5 0 010 1h-4a.5.5 0 00-.5.5v4a.5.5 0 01-1 0v-4z" }) });
}

// src/icon/FullscreenIcon.tsx
var import_react_native_svg14 = __toESM(require("react-native-svg"));
var import_react_native_theming17 = require("@storybook/react-native-theming");
var import_react27 = require("react");
var import_jsx_runtime29 = require("react/jsx-runtime");
function FullscreenIcon({ color, width = 14, height = 14, ...props }) {
  const theme = (0, import_react_native_theming17.useTheme)();
  const fillColor = (0, import_react27.useMemo)(() => {
    return color ?? theme.color.defaultText;
  }, [color, theme.color.defaultText]);
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(import_react_native_svg14.default, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
    import_react_native_svg14.Path,
    {
      d: "M1.5 1h2a.5.5 0 010 1h-.793l3.147 3.146a.5.5 0 11-.708.708L2 2.707V3.5a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm8.5.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-.793L8.854 5.854a.5.5 0 11-.708-.708L11.293 2H10.5a.5.5 0 01-.5-.5zm2.5 8.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.793L8.146 8.854a.5.5 0 11.708-.708L12 11.293V10.5a.5.5 0 01.5-.5zM2 11.293V10.5a.5.5 0 00-1 0v2a.5.5 0 00.5.5h2a.5.5 0 000-1h-.793l3.147-3.146a.5.5 0 10-.708-.708L2 11.293z",
      fill: fillColor
    }
  ) });
}

// src/icon/MenuIcon.tsx
var import_react_native_svg15 = require("react-native-svg");
var import_jsx_runtime30 = require("react/jsx-runtime");
var MenuIcon = ({
  color = "currentColor",
  width = 14,
  height = 14,
  ...props
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(import_react_native_svg15.Svg, { width, height, viewBox: "0 0 14 14", fill: "none", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
    import_react_native_svg15.Path,
    {
      d: "M13 3.5a.5.5 0 010 1H1a.5.5 0 010-1h12zM13.5 10a.5.5 0 00-.5-.5H1a.5.5 0 000 1h12a.5.5 0 00.5-.5zM13 6.5a.5.5 0 010 1H1a.5.5 0 010-1h12z",
      fill: color
    }
  ) });
};

// src/Layout.tsx
var import_jsx_runtime31 = require("react/jsx-runtime");
var desktopLogoContainer = {
  flexDirection: "row",
  alignItems: "center",
  paddingTop: 10,
  paddingLeft: 16,
  paddingBottom: 4,
  paddingRight: 10,
  justifyContent: "space-between"
};
var contentContainerStyle = { flex: 1, overflow: "hidden" };
var mobileContentStyle = { flex: 1, overflow: "hidden" };
var placeholderObject = {};
var placeholderArray = [];
var iconFloatRightStyle = { marginLeft: "auto" };
var navButtonStyle = { flexShrink: 1 };
var navButtonHitSlop = { bottom: 10, left: 10, right: 10, top: 10 };
var mobileMenuDrawerContentStyle = {
  paddingLeft: 16,
  paddingTop: 4,
  paddingBottom: 4
};
var Layout = ({
  storyHash,
  story,
  children
}) => {
  const theme = (0, import_react_native_theming18.useTheme)();
  const mobileMenuDrawerRef = (0, import_react28.useRef)(null);
  const addonPanelRef = (0, import_react28.useRef)(null);
  const insets = (0, import_react_native_safe_area_context3.useSafeAreaInsets)();
  const { isDesktop } = useLayout();
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useStoreBooleanState(
    "desktopSidebarState",
    true
  );
  const [desktopAddonsPanelOpen, setDesktopAddonsPanelOpen] = useStoreBooleanState(
    "desktopPanelState",
    true
  );
  const [uiHidden, setUiHidden] = (0, import_react28.useState)(false);
  const desktopSidebarStyle = useStyle(
    () => ({
      width: desktopSidebarOpen ? 240 : void 0,
      padding: desktopSidebarOpen ? 0 : 10,
      borderColor: theme.appBorderColor,
      borderRightWidth: 1
    }),
    [desktopSidebarOpen, theme.appBorderColor]
  );
  const desktopScrollViewContentContainerStyle = useStyle(
    () => ({
      paddingBottom: insets.bottom
    }),
    [insets.bottom]
  );
  const desktopAddonsPanelStyle = useStyle(
    () => ({
      height: desktopAddonsPanelOpen ? 300 : void 0,
      borderTopWidth: 1,
      borderColor: theme.appBorderColor,
      paddingTop: desktopAddonsPanelOpen ? 4 : 0,
      padding: desktopAddonsPanelOpen ? 0 : 10
    }),
    [desktopAddonsPanelOpen, theme.appBorderColor]
  );
  const containerStyle = useStyle(() => {
    if (isDesktop) {
      return {
        flex: 1,
        paddingTop: insets.top,
        backgroundColor: theme.background.content,
        flexDirection: "row"
      };
    }
    return {
      flex: 1,
      paddingTop: story?.parameters?.noSafeArea ? 0 : insets.top,
      backgroundColor: theme.background.content
    };
  }, [theme.background.content, insets.top, story?.parameters?.noSafeArea, isDesktop]);
  const fullScreenButtonStyle = useStyle(
    () => ({
      position: "absolute",
      bottom: uiHidden ? 56 + insets.bottom : 16,
      right: 16,
      backgroundColor: theme.background.content,
      padding: 4,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: theme.appBorderColor
    }),
    [uiHidden, insets.bottom, theme.background.content, theme.appBorderColor]
  );
  const menuContainerStyle = useStyle(
    () => ({
      marginBottom: insets.bottom
    }),
    [insets.bottom]
  );
  const navButtonTextStyle = useStyle(
    () => ({
      flexShrink: 1,
      color: theme.barTextColor
    }),
    [theme.barTextColor]
  );
  const openMobileMenu = (0, import_react28.useCallback)(() => {
    mobileMenuDrawerRef.current.setMobileMenuOpen(true);
  }, [mobileMenuDrawerRef]);
  const setSelection = (0, import_react28.useCallback)(({ storyId: newStoryId }) => {
    const channel = import_manager_api2.addons.getChannel();
    channel.emit(import_core_events.SET_CURRENT_STORY, { storyId: newStoryId });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(import_react_native9.View, { style: containerStyle, children: [
    isDesktop ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_react_native9.View, { style: desktopSidebarStyle, children: desktopSidebarOpen ? /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(
      import_react_native9.ScrollView,
      {
        keyboardShouldPersistTaps: "handled",
        contentContainerStyle: desktopScrollViewContentContainerStyle,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(import_react_native9.View, { style: desktopLogoContainer, children: [
            /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(StorybookLogo, { theme }),
            /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(IconButton, { onPress: () => setDesktopSidebarOpen(false), Icon: MenuIcon })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
            Sidebar,
            {
              extra: placeholderArray,
              previewInitialized: true,
              indexError: void 0,
              refs: placeholderObject,
              setSelection,
              status: placeholderObject,
              index: storyHash,
              storyId: story?.id,
              refId: DEFAULT_REF_ID
            }
          )
        ]
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(IconButton, { onPress: () => setDesktopSidebarOpen(true), Icon: MenuIcon }) }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(import_react_native9.View, { style: mobileContentStyle, children: [
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_react_native9.View, { style: contentContainerStyle, children }),
      story?.parameters?.hideFullScreenButton || isDesktop ? null : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        import_react_native9.TouchableOpacity,
        {
          style: fullScreenButtonStyle,
          onPress: () => setUiHidden((prev) => !prev),
          children: uiHidden ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(CloseFullscreenIcon, { color: theme.color.mediumdark }) : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(FullscreenIcon, { color: theme.color.mediumdark })
        }
      ),
      isDesktop ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_react_native9.View, { style: desktopAddonsPanelStyle, children: desktopAddonsPanelOpen ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(AddonsTabs, { storyId: story?.id, onClose: () => setDesktopAddonsPanelOpen(false) }) : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        IconButton,
        {
          style: iconFloatRightStyle,
          onPress: () => setDesktopAddonsPanelOpen(true),
          Icon: BottomBarToggleIcon
        }
      ) }) : null
    ] }),
    !uiHidden && !isDesktop ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(Container3, { style: menuContainerStyle, children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(Nav, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(
        Button2,
        {
          testID: "mobile-menu-button",
          style: navButtonStyle,
          hitSlop: navButtonHitSlop,
          onPress: openMobileMenu,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(MenuIcon, { color: theme.color.mediumdark }),
            /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(import_react_native9.Text, { style: navButtonTextStyle, numberOfLines: 1, children: [
              story?.title,
              "/",
              story?.name
            ] })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        IconButton,
        {
          testID: "mobile-addons-button",
          onPress: () => addonPanelRef.current.setAddonsPanelOpen(true),
          Icon: BottomBarToggleIcon
        }
      )
    ] }) }) : null,
    isDesktop ? null : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(SelectedNodeProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(MobileMenuDrawer, { ref: mobileMenuDrawerRef, children: [
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_react_native9.View, { style: mobileMenuDrawerContentStyle, children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(StorybookLogo, { theme }) }),
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        Sidebar,
        {
          extra: placeholderArray,
          previewInitialized: true,
          indexError: void 0,
          refs: placeholderObject,
          setSelection,
          status: placeholderObject,
          index: storyHash,
          storyId: story?.id,
          refId: DEFAULT_REF_ID
        }
      )
    ] }) }),
    isDesktop ? null : /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(MobileAddonsPanel, { ref: addonPanelRef, storyId: story?.id })
  ] });
};
var Nav = import_react_native_theming18.styled.View({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  height: 40,
  paddingHorizontal: 6
});
var Container3 = import_react_native_theming18.styled.View(({ theme }) => ({
  alignSelf: "flex-end",
  width: "100%",
  backgroundColor: theme.barBg,
  borderTopColor: theme.appBorderColor,
  borderTopWidth: 1
}));
var Button2 = import_react_native_theming18.styled.TouchableOpacity(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 10,
  color: theme.color.mediumdark,
  fontSize: theme.typography.size?.s2 - 1,
  paddingHorizontal: 7,
  fontWeight: theme.typography.weight.bold
}));

// ../../node_modules/@storybook/csf/dist/index.mjs
var C = Object.create;
var u = Object.defineProperty;
var B = Object.getOwnPropertyDescriptor;
var F = Object.getOwnPropertyNames;
var h = Object.getPrototypeOf;
var w = Object.prototype.hasOwnProperty;
var E = (r, e) => () => (e || r((e = { exports: {} }).exports, e), e.exports);
var v = (r, e, n, t) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let a of F(e))
      !w.call(r, a) && a !== n && u(r, a, { get: () => e[a], enumerable: !(t = B(e, a)) || t.enumerable });
  return r;
};
var I = (r, e, n) => (n = r != null ? C(h(r)) : {}, v(e || !r || !r.__esModule ? u(n, "default", { value: r, enumerable: true }) : n, r));
var x = E((T) => {
  Object.defineProperty(T, "__esModule", { value: true }), T.isEqual = function() {
    var r = Object.prototype.toString, e = Object.getPrototypeOf, n = Object.getOwnPropertySymbols ? function(t) {
      return Object.keys(t).concat(Object.getOwnPropertySymbols(t));
    } : Object.keys;
    return function(t, a) {
      return function i(o, s, p) {
        var g, y, d, c = r.call(o), b = r.call(s);
        if (o === s)
          return true;
        if (o == null || s == null)
          return false;
        if (p.indexOf(o) > -1 && p.indexOf(s) > -1)
          return true;
        if (p.push(o, s), c != b || (g = n(o), y = n(s), g.length != y.length || g.some(function(A) {
          return !i(o[A], s[A], p);
        })))
          return false;
        switch (c.slice(8, -1)) {
          case "Symbol":
            return o.valueOf() == s.valueOf();
          case "Date":
          case "Number":
            return +o == +s || +o != +o && +s != +s;
          case "RegExp":
          case "Function":
          case "String":
          case "Boolean":
            return "" + o == "" + s;
          case "Set":
          case "Map":
            g = o.entries(), y = s.entries();
            do
              if (!i((d = g.next()).value, y.next().value, p))
                return false;
            while (!d.done);
            return true;
          case "ArrayBuffer":
            o = new Uint8Array(o), s = new Uint8Array(s);
          case "DataView":
            o = new Uint8Array(o.buffer), s = new Uint8Array(s.buffer);
          case "Float32Array":
          case "Float64Array":
          case "Int8Array":
          case "Int16Array":
          case "Int32Array":
          case "Uint8Array":
          case "Uint16Array":
          case "Uint32Array":
          case "Uint8ClampedArray":
          case "Arguments":
          case "Array":
            if (o.length != s.length)
              return false;
            for (d = 0; d < o.length; d++)
              if ((d in o || d in s) && (d in o != d in s || !i(o[d], s[d], p)))
                return false;
            return true;
          case "Object":
            return i(e(o), e(s), p);
          default:
            return false;
        }
      }(t, a, []);
    };
  }();
});
var l = I(x());
var O = (r) => r.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");

// src/util/StoryHash.ts
var import_countBy = __toESM(require("lodash/countBy.js"));

// ../../node_modules/ts-dedent/esm/index.js
function dedent(templ) {
  var values = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }
  var strings = Array.from(typeof templ === "string" ? [templ] : templ);
  strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var indentLengths = strings.reduce(function(arr, str) {
    var matches = str.match(/\n([\t ]+|(?!\s).)/g);
    if (matches) {
      return arr.concat(matches.map(function(match) {
        var _a, _b;
        return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
      }));
    }
    return arr;
  }, []);
  if (indentLengths.length) {
    var pattern_1 = new RegExp("\n[	 ]{" + Math.min.apply(Math, indentLengths) + "}", "g");
    strings = strings.map(function(str) {
      return str.replace(pattern_1, "\n");
    });
  }
  strings[0] = strings[0].replace(/^\r?\n/, "");
  var string = strings[0];
  values.forEach(function(value, i) {
    var endentations = string.match(/(?:^|\n)( *)$/);
    var endentation = endentations ? endentations[1] : "";
    var indentedValue = value;
    if (typeof value === "string" && value.includes("\n")) {
      indentedValue = String(value).split("\n").map(function(str, i2) {
        return i2 === 0 ? str : "" + endentation + str;
      }).join("\n");
    }
    string += indentedValue + strings[i + 1];
  });
  return string;
}

// src/util/StoryHash.ts
var import_isEqual = __toESM(require("lodash/isEqual.js"));
var import_mergeWith = __toESM(require("lodash/mergeWith.js"));
var import_client_logger = require("@storybook/core/client-logger");
var merge = (a, b) => (0, import_mergeWith.default)({}, a, b, (objValue, srcValue) => {
  if (Array.isArray(srcValue) && Array.isArray(objValue)) {
    srcValue.forEach((s) => {
      const existing = objValue.find((o) => o === s || (0, import_isEqual.default)(o, s));
      if (!existing) {
        objValue.push(s);
      }
    });
    return objValue;
  }
  if (Array.isArray(objValue)) {
    import_client_logger.logger.log(["the types mismatch, picking", objValue]);
    return objValue;
  }
  return void 0;
});
var TITLE_PATH_SEPARATOR = /\s*\/\s*/;
var transformStoryIndexToStoriesHash = (input, { provider, docsOptions, filters, status }) => {
  if (!input.v) {
    throw new Error("Composition: Missing stories.json version");
  }
  let index = input;
  index = index.v === 2 ? transformStoryIndexV2toV3(index) : index;
  index = index.v === 3 ? transformStoryIndexV3toV4(index) : index;
  index = index;
  const entryValues = Object.values(index.entries).filter((entry) => {
    let result = true;
    Object.values(filters).forEach((filter) => {
      if (result === false) {
        return;
      }
      result = filter({ ...entry, status: status[entry.id] });
    });
    return result;
  });
  const { sidebar = {} } = provider.getConfig();
  const { showRoots, collapsedRoots = [], renderLabel } = sidebar;
  const setShowRoots = typeof showRoots !== "undefined";
  const storiesHashOutOfOrder = entryValues.reduce((acc, item) => {
    if (docsOptions.docsMode && item.type !== "docs") {
      return acc;
    }
    const { title } = item;
    const groups = title.trim().split(TITLE_PATH_SEPARATOR);
    const root = (!setShowRoots || showRoots) && groups.length > 1 ? [groups.shift()] : [];
    const names = [...root, ...groups];
    const paths = names.reduce((list, name, idx) => {
      const parent = idx > 0 && list[idx - 1];
      const id = O(parent ? `${parent}-${name}` : name);
      if (parent === id) {
        throw new Error(
          dedent`
          Invalid part '${name}', leading to id === parentId ('${id}'), inside title '${title}'
          
          Did you create a path that uses the separator char accidentally, such as 'Vue <docs/>' where '/' is a separator char? See https://github.com/storybookjs/storybook/issues/6128
          `
        );
      }
      list.push(id);
      return list;
    }, []);
    paths.forEach((id, idx) => {
      const childId = paths[idx + 1] || item.id;
      if (root.length && idx === 0) {
        acc[id] = merge(acc[id] || {}, {
          type: "root",
          id,
          name: names[idx],
          depth: idx,
          renderLabel,
          startCollapsed: collapsedRoots.includes(id),
          // Note that this will later get appended to the previous list of children (see below)
          children: [childId]
        });
      } else if ((!acc[id] || acc[id].type === "component") && idx === paths.length - 1) {
        acc[id] = merge(acc[id] || {}, {
          type: "component",
          id,
          name: names[idx],
          parent: paths[idx - 1],
          depth: idx,
          renderLabel,
          ...childId && {
            children: [childId]
          }
        });
      } else {
        acc[id] = merge(acc[id] || {}, {
          type: "group",
          id,
          name: names[idx],
          parent: paths[idx - 1],
          depth: idx,
          renderLabel,
          ...childId && {
            children: [childId]
          }
        });
      }
    });
    acc[item.id] = {
      type: "story",
      ...item,
      depth: paths.length,
      parent: paths[paths.length - 1],
      renderLabel,
      prepared: !!item.parameters
    };
    return acc;
  }, {});
  function addItem(acc, item) {
    if (acc[item.id]) {
      return acc;
    }
    acc[item.id] = item;
    if (item.type === "root" || item.type === "group" || item.type === "component") {
      item.children.forEach((childId) => addItem(acc, storiesHashOutOfOrder[childId]));
    }
    return acc;
  }
  const orphanHash = Object.values(storiesHashOutOfOrder).filter((i) => i.type !== "root" && !i.parent).reduce(addItem, {});
  return Object.values(storiesHashOutOfOrder).filter((i) => i.type === "root").reduce(addItem, orphanHash);
};
var transformStoryIndexV2toV3 = (index) => {
  return {
    v: 3,
    stories: Object.values(index.stories).reduce((acc, entry) => {
      acc[entry.id] = {
        ...entry,
        title: entry.kind,
        name: entry.name || entry.story,
        importPath: entry.parameters.fileName || ""
      };
      return acc;
    }, {})
  };
};
var transformStoryIndexV3toV4 = (index) => {
  const countByTitle = (0, import_countBy.default)(Object.values(index.stories), "title");
  return {
    v: 4,
    entries: Object.values(index.stories).reduce((acc, entry) => {
      let type = "story";
      if (entry.parameters?.docsOnly || entry.name === "Page" && countByTitle[entry.title] === 1) {
        type = "docs";
      }
      acc[entry.id] = {
        type,
        ...type === "docs" && { tags: ["stories-mdx"], storiesImports: [] },
        ...entry
      };
      delete acc[entry.id].story;
      delete acc[entry.id].kind;
      return acc;
    }, {})
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button,
  ButtonIcon,
  ButtonText,
  ComponentNode,
  Explorer,
  GroupNode,
  IconButton,
  Layout,
  LayoutProvider,
  LeafNodeStyleWrapper,
  Node,
  RootNode,
  RootNodeText,
  Sidebar,
  StorageProvider,
  StoryNode,
  Tree,
  isExpandType,
  transformStoryIndexToStoriesHash,
  transformStoryIndexV2toV3,
  transformStoryIndexV3toV4,
  useCombination,
  useLayout,
  useStorage
});
